"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
* jQuery Form Validator
* ------------------------------------------
* Created by Victor Jonsson <http://www.victorjonsson.se>
*
* @website http://formvalidator.net/
* @license Dual licensed under the MIT or GPL Version 2 licenses
* @version 2.1.47
*/
(function ($) {
  'use strict';

  var _applyErrorStyle = function _applyErrorStyle($elem, conf) {
      $elem.addClass(conf.errorElementClass).removeClass('valid').parent().addClass('has-error').removeClass('has-success'); // twitter bs

      if (conf.borderColorOnError !== '') {
        $elem.css('border-color', conf.borderColorOnError);
      }
    },
    _removeErrorStyle = function _removeErrorStyle($elem, conf) {
      $elem.each(function () {
        _setInlineErrorMessage($(this), '', conf, conf.errorMessagePosition);
        $(this).removeClass('valid').removeClass(conf.errorElementClass).css('border-color', '').parent().removeClass('has-error').removeClass('has-success').find('.' + conf.errorMessageClass) // remove inline error message
        .remove();
      });
    },
    _setInlineErrorMessage = function _setInlineErrorMessage($input, mess, conf, $messageContainer) {
      var custom = _getInlineErrorElement($input);
      if (custom) {
        custom.innerHTML = mess;
      } else if (_typeof($messageContainer) == 'object') {
        var $found = false;
        $messageContainer.find('.' + conf.errorMessageClass).each(function () {
          if (this.inputReferer == $input[0]) {
            $found = $(this);
            return false;
          }
        });
        if ($found) {
          if (!mess) {
            $found.remove();
          } else {
            $found.html(mess);
          }
        } else {
          var $mess = $('<div class="' + conf.errorMessageClass + '">' + mess + '</div>');
          $mess[0].inputReferer = $input[0];
          $messageContainer.prepend($mess);
        }
      } else {
        var $mess = $input.parent().find('.' + conf.errorMessageClass + '.help-block');
        if ($mess.length == 0) {
          $mess = $('<span></span>').addClass('help-block').addClass(conf.errorMessageClass);
          $mess.appendTo($input.parent());
        }
        $mess.html(mess);
      }
    },
    _getInlineErrorElement = function _getInlineErrorElement($input, conf) {
      return document.getElementById($input.attr('name') + '_err_msg');
    };

  /**
  * Assigns validateInputOnBlur function to elements blur event
  *
  * @param {Object} language Optional, will override $.formUtils.LANG
  * @param {Object} settings Optional, will override the default settings
  * @return {jQuery}
  */
  $.fn.validateOnBlur = function (language, settings) {
    this.find('input[data-validation],textarea[data-validation],select[data-validation]').bind('blur.validation', function () {
      $(this).validateInputOnBlur(language, settings);
    });
    return this;
  };

  /*
   * Assigns validateInputOnBlur function to elements custom event
   * @param {Object} language Optional, will override $.formUtils.LANG
   * @param {Object} settings Optional, will override the default settings
   * * @return {jQuery}	
   */
  $.fn.validateOnEvent = function (language, settings) {
    this.find('input[data-validation][data-validation-event],textarea[data-validation][data-validation-event],select[data-validation][data-validation-event]').each(function () {
      var $el = $(this),
        etype = $el.attr("data-validation-event");
      if (etype) {
        $el.bind(etype + ".validation", function () {
          $(this).validateInputOnBlur(language, settings, false, etype);
        });
      }
    });
    return this;
  };

  /**
  * fade in help message when input gains focus
  * fade out when input loses focus
  * <input data-help="The info that I want to display for the user when input is focused" ... />
  *
  * @param {String} attrName - Optional, default is data-help
  * @return {jQuery}
  */
  $.fn.showHelpOnFocus = function (attrName) {
    if (!attrName) {
      attrName = 'data-validation-help';
    }

    // Remove previously added event listeners
    this.find('.has-help-txt').valAttr('has-keyup-event', false).valAttr('backend-valid', false).valAttr('backend-invalid', false).removeClass('has-help-txt');

    // Add help text listeners
    this.find('textarea,input').each(function () {
      var $elem = $(this),
        className = 'jquery_form_help_' + ($elem.attr('name') || '').replace(/(:|\.|\[|\])/g, ""),
        help = $elem.attr(attrName);
      if (help) {
        $elem.addClass('has-help-txt').unbind('focus.help').bind('focus.help', function () {
          var $help = $elem.parent().find('.' + className);
          if ($help.length == 0) {
            $help = $('<span />').addClass(className).addClass('help').addClass('help-block') // twitter bs
            .text(help).hide();
            $elem.after($help);
          }
          $help.fadeIn();
        }).unbind('blur.help').bind('blur.help', function () {
          $(this).parent().find('.' + className).fadeOut('slow');
        });
      }
    });
    return this;
  };

  /**
  * Validate single input when it loses focus
  * shows error message in a span element 
  * that is appended to the parent element
  *
  * @param {Object} [language] Optional, will override $.formUtils.LANG
  * @param {Object} [conf] Optional, will override the default settings
  * @param {Boolean} [attachKeyupEvent] Optional
  * @param {String} [eventContext]
  * @return {jQuery}
  */
  $.fn.validateInputOnBlur = function (language, conf, attachKeyupEvent, eventContext) {
    if (attachKeyupEvent === undefined) attachKeyupEvent = true;
    if (!eventContext) eventContext = 'blur';
    if ((this.valAttr('suggestion-nr') || this.valAttr('postpone') || this.hasClass('hasDatepicker')) && !window.postponedValidation) {
      // This validation has to be postponed 
      var _self = this,
        postponeTime = this.valAttr('postpone') || 200;
      window.postponedValidation = function () {
        _self.validateInputOnBlur(language, conf, attachKeyupEvent);
        window.postponedValidation = false;
      };
      setTimeout(function () {
        if (window.postponedValidation) {
          window.postponedValidation();
        }
      }, postponeTime);
      return this;
    }
    language = $.extend({}, $.formUtils.LANG, language || {});
    _removeErrorStyle(this, conf);
    var $elem = this,
      $form = $elem.closest("form"),
      validationRule = $elem.attr(conf.validationRuleAttribute),
      validation = $.formUtils.validateInput($elem, language, $.extend({}, conf, {
        errorMessagePosition: 'element'
      }), $form, eventContext);
    $elem.trigger('validation', [validation === null ? null : validation === true]);
    if (validation === true) {
      $elem.addClass('valid').parent().addClass('has-success'); // twitter bs
    } else if (validation !== null) {
      _applyErrorStyle($elem, conf);
      _setInlineErrorMessage($elem, validation, conf, conf.errorMessagePosition);
      if (attachKeyupEvent) {
        $elem.bind('keyup', function () {
          $(this).validateInputOnBlur(language, conf, false, 'keyup');
        });
      }
    }
    return this;
  };

  /**
   * Short hand for fetching/adding/removing element attributes
   * prefixed with 'data-validation-'
   *
   * @param {String} name
   * @param {String|Boolean} [val]
   * @return string|undefined
   * @protected
   */
  $.fn.valAttr = function (name, val) {
    if (val === undefined) {
      return this.attr('data-validation-' + name);
    } else if (val === false || val === null) {
      return this.removeAttr('data-validation-' + name);
    } else {
      if (name.length > 0) name = '-' + name;
      return this.attr('data-validation' + name, val);
    }
  };

  /**
   * Function that validate all inputs in a form
   *
   * @param [language]
   * @param [conf]
   */
  $.fn.validateForm = function (language, conf) {
    language = $.extend({}, $.formUtils.LANG, language || {});
    $.formUtils.isValidatingEntireForm = true;
    $.formUtils.haltValidation = false;

    /**
     * Adds message to error message stack if not already in the message stack
     *
     * @param {String} mess
     * @para {jQuery} $elem
     */
    var addErrorMessage = function addErrorMessage(mess, $elem) {
        // validate server side will return null as error message before the server is requested
        if (mess !== null) {
          if ($.inArray(mess, errorMessages) < 0) {
            errorMessages.push(mess);
          }
          errorInputs.push($elem);
          $elem.attr('current-error', mess);
          _applyErrorStyle($elem, conf);
        }
      },
      /** Error messages for this validation */
      errorMessages = [],
      /** Input elements which value was not valid */
      errorInputs = [],
      /** Form instance */
      $form = this,
      /**
       * Tells whether or not to validate element with this name and of this type
       *
       * @param {String} name
       * @param {String} type
       * @return {Boolean}
       */
      ignoreInput = function ignoreInput(name, type) {
        if (type === 'submit' || type === 'button' || type == 'reset') {
          return true;
        }
        return $.inArray(name, conf.ignore || []) > -1;
      };

    // Reset style and remove error class
    $form.find('.' + conf.errorMessageClass + '.alert').remove();
    _removeErrorStyle($form.find('.' + conf.errorElementClass + ',.valid'), conf);

    // Validate element values
    $form.find('input,textarea,select').filter(':not([type="submit"],[type="button"])').each(function () {
      var $elem = $(this);
      var elementType = $elem.attr('type');
      if (!ignoreInput($elem.attr('name'), elementType)) {
        var validation = $.formUtils.validateInput($elem, language, conf, $form, 'submit');
        $elem.trigger('validation', [validation === true]);
        if (validation !== true) {
          addErrorMessage(validation, $elem);
        } else {
          $elem.valAttr('current-error', false).addClass('valid').parent().addClass('has-success');
        }
      }
    });

    // Run validation callback
    if (typeof conf.onValidate == 'function') {
      var errors = conf.onValidate($form);
      if ($.isArray(errors)) {
        $.each(errors, function (i, err) {
          addErrorMessage(err.message, err.element);
        });
      } else if (errors && errors.element && errors.message) {
        addErrorMessage(errors.message, errors.element);
      }
    }

    // Validation failed
    if (!$.formUtils.haltValidation && errorInputs.length > 0) {
      // Reset form validation flag
      $.formUtils.isValidatingEntireForm = false;

      // display all error messages in top of form
      if (conf.errorMessagePosition === 'top') {
        var messages = '<strong>' + language.errorTitle + '</strong>';
        $.each(errorMessages, function (i, mess) {
          messages += '<br />* ' + mess;
        });

        // using div instead of P gives better control of css display properties
        $form.children().eq(0).before('<div class="' + conf.errorMessageClass + ' alert alert-danger">' + messages + '</div>');
      }

      // Display error message below input field or in defined container
      else {
        $.each(errorInputs, function (i, $input) {
          _setInlineErrorMessage($input, $input.attr('current-error'), conf, conf.errorMessagePosition);
        });
      }
      if (conf.scrollToTopOnError) {
        $(window).scrollTop($form.offset().top - 20);
      }
      return false;
    }

    // Reset form validation flag
    $.formUtils.isValidatingEntireForm = false;
    return !$.formUtils.haltValidation;
  };

  /**
  * Plugin for displaying input length restriction
  */
  $.fn.restrictLength = function (maxLengthElement) {
    new $.formUtils.lengthRestriction(this, maxLengthElement);
    return this;
  };

  /**
   * Add suggestion dropdown to inputs having data-suggestions with a comma
   * separated string with suggestions
   * @param {Array} [settings]
   * @returns {jQuery}
   */
  $.fn.addSuggestions = function (settings) {
    var sugs = false;
    this.find('input').each(function () {
      var $field = $(this);
      sugs = $.split($field.attr('data-suggestions'));
      if (sugs.length > 0 && !$field.hasClass('has-suggestions')) {
        $.formUtils.suggest($field, sugs, settings);
        $field.addClass('has-suggestions');
      }
    });
    return this;
  };

  /**
   * A bit smarter split function
   * @param {String} val
   * @param {Function|String} [func]
   * @param {String} [delim]
   * @returns {Array|void}
   */
  $.split = function (val, func, delim) {
    if (typeof func != 'function') {
      // return string
      if (!val) return [];
      var values = [];
      $.each(val.split(func ? func : ','), function (i, str) {
        str = $.trim(str);
        if (str.length) values.push(str);
      });
      return values;
    } else if (val) {
      // use callback on each
      if (!delim) delim = ',';
      $.each(val.split(delim), function (i, str) {
        str = $.trim(str);
        if (str.length) return func(str, i);
      });
    }
  };

  /**
   * Short hand function that makes the validation setup require less code
   * @param conf
   */
  $.validate = function (conf) {
    var defaultConf = $.extend($.formUtils.defaultConfig(), {
      form: 'form',
      /*
       * Enable custom event for validation
       */
      validateOnEvent: true,
      validateOnBlur: true,
      showHelpOnFocus: true,
      addSuggestions: true,
      modules: '',
      onModulesLoaded: null,
      language: false,
      onSuccess: false,
      onError: false
    });
    conf = $.extend(defaultConf, conf || {});

    // Add validation to forms
    $.split(conf.form, function (formQuery) {
      var $form = $(formQuery);

      // Remove all event listeners previously added
      $form.find('.has-help-txt').unbind('focus.validation').unbind('blur.validation');
      $form.removeClass('has-validation-callback').unbind('submit.validation').unbind('reset.validation').find('input[data-validation],textarea[data-validation]').unbind('blur.validation');

      // Validate when submitted
      $form.bind('submit.validation', function () {
        var $form = $(this);
        if ($.formUtils.isLoadingModules) {
          setTimeout(function () {
            $form.trigger('submit.validation');
          }, 200);
          return false;
        }
        var valid = $form.validateForm(conf.language, conf);
        if (valid && typeof conf.onSuccess == 'function') {
          var callbackResponse = conf.onSuccess($form);
          if (callbackResponse === false) return false;
        } else if (!valid && typeof conf.onError == 'function') {
          conf.onError($form);
          return false;
        } else {
          return valid;
        }
      }).bind('reset.validation', function () {
        // remove messages
        $(this).find('.' + conf.errorMessageClass + '.alert').remove();
        _removeErrorStyle($(this).find('.' + conf.errorElementClass + ',.valid'), conf);
      }).addClass('has-validation-callback');
      if (conf.showHelpOnFocus) {
        $form.showHelpOnFocus();
      }
      if (conf.addSuggestions) {
        $form.addSuggestions();
      }
      if (conf.validateOnBlur) {
        $form.validateOnBlur(conf.language, conf);
      }
      if (conf.validateOnEvent) {
        $form.validateOnEvent(conf.language, conf);
      }
    });
    if (conf.modules != '') {
      if (typeof conf.onModulesLoaded == 'function') {
        $.formUtils.on('load', function () {
          conf.onModulesLoaded();
        });
      }
      $.formUtils.loadModules(conf.modules);
    }
  };

  /**
   * Object containing utility methods for this plugin
   */
  $.formUtils = {
    /**
     * Default config for $(...).validateForm();
     */
    defaultConfig: function defaultConfig() {
      return {
        ignore: [],
        // Names of inputs not to be validated even though node attribute containing the validation rules tells us to
        errorElementClass: 'error',
        // Class that will be put on elements which value is invalid
        borderColorOnError: 'red',
        // Border color of elements which value is invalid, empty string to not change border color
        errorMessageClass: 'form-error',
        // class name of div containing error messages when validation fails
        validationRuleAttribute: 'data-validation',
        // name of the attribute holding the validation rules
        validationErrorMsgAttribute: 'data-validation-error-msg',
        // define custom err msg inline with element
        errorMessagePosition: 'element',
        // Can be either "top" or "element"
        scrollToTopOnError: true,
        dateFormat: 'yyyy-mm-dd',
        addValidClassOnAll: false,
        // whether or not to apply class="valid" even if the input wasn't validated
        decimalSeparator: '.'
      };
    },
    /**
    * Available validators
    */
    validators: {},
    /**
     * Events triggered by form validator
     */
    _events: {
      load: [],
      valid: [],
      invalid: []
    },
    /**
     * Setting this property to true during validation will
     * stop further validation from taking place and form will
     * not be sent
     */
    haltValidation: false,
    /**
     * This variable will be true $.fn.validateForm() is called
     * and false when $.fn.validateOnBlur is called
     */
    isValidatingEntireForm: false,
    /**
    * Function for adding a validator
    * @param {Object} validator
    */
    addValidator: function addValidator(validator) {
      // prefix with "validate_" for backward compatibility reasons
      var name = validator.name.indexOf('validate_') === 0 ? validator.name : 'validate_' + validator.name;
      if (validator.validateOnKeyUp === undefined) validator.validateOnKeyUp = true;
      this.validators[name] = validator;
    },
    /**
     * @param {String} evt
     * @param {Function} callback
     */
    on: function on(evt, callback) {
      // Why not use $(document).bind('validators.loaded', func);
      if (this._events[evt] === undefined) this._events[evt] = [];
      this._events[evt].push(callback);
    },
    /**
     * @param {String} evt
     * @param [argA]
     * @param [argB]
     */
    trigger: function trigger(evt, argA, argB) {
      $.each(this._events[evt] || [], function (i, func) {
        func(argA, argB);
      });
    },
    /**
     * @ {Boolean}
     */
    isLoadingModules: false,
    loadedModules: {},
    /**
    * @example
    *  $.formUtils.loadModules('date, security.dev');
    *
    * Will load the scripts date.js and security.dev.js from the
    * directory where this script resides. If you want to load
    * the modules from another directory you can use the
    * path argument.
    *
    * The script will be cached by the browser unless the module
    * name ends with .dev
    *
    * @param {String} modules - Comma separated string with module file names (no directory nor file extension)
    * @param {String} [path] - Optional, path where the module files is located if their not in the same directory as the core modules
    * @param {Boolean} [fireEvent] - Optional, whether or not to fire event 'load' when modules finished loading
    */
    loadModules: function loadModules(modules, path, fireEvent) {
      if (fireEvent === undefined) fireEvent = true;
      if ($.formUtils.isLoadingModules) {
        setTimeout(function () {
          $.formUtils.loadModules(modules, path, fireEvent);
        });
        return;
      }
      var hasLoadedAnyModule = false,
        loadModuleScripts = function loadModuleScripts(modules, path) {
          var moduleList = $.split(modules),
            numModules = moduleList.length,
            moduleLoadedCallback = function moduleLoadedCallback() {
              numModules--;
              if (numModules == 0) {
                $.formUtils.isLoadingModules = false;
                if (fireEvent && hasLoadedAnyModule) {
                  $.formUtils.trigger('load', path);
                }
              }
            };
          if (numModules > 0) {
            $.formUtils.isLoadingModules = true;
          }
          var cacheSuffix = '?__=' + new Date().getTime(),
            appendToElement = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
          $.each(moduleList, function (i, modName) {
            modName = $.trim(modName);
            if (modName.length == 0) {
              moduleLoadedCallback();
            } else {
              var scriptUrl = path + modName + (modName.substr(-3) == '.js' ? '' : '.js'),
                script = document.createElement('SCRIPT');
              if (scriptUrl in $.formUtils.loadedModules) {
                // already loaded
                moduleLoadedCallback();
              } else {
                // Remember that this script is loaded
                $.formUtils.loadedModules[scriptUrl] = 1;
                hasLoadedAnyModule = true;

                // Load the script
                script.type = 'text/javascript';
                script.onload = moduleLoadedCallback;
                script.src = scriptUrl + (scriptUrl.substr(-7) == '.dev.js' ? cacheSuffix : '');
                script.onreadystatechange = function () {
                  // IE 7 fix
                  if (this.readyState == 'complete') {
                    moduleLoadedCallback();
                  }
                };
                appendToElement.appendChild(script);
              }
            }
          });
        };
      if (path) {
        loadModuleScripts(modules, path);
      } else {
        var findScriptPathAndLoadModules = function findScriptPathAndLoadModules() {
          var foundPath = false;
          $('script').each(function () {
            if (this.src) {
              var scriptName = this.src.substr(this.src.lastIndexOf('/') + 1, this.src.length);
              if (scriptName.indexOf('jquery.form-validator.js') > -1 || scriptName.indexOf('jquery.form-validator.min.js') > -1) {
                foundPath = this.src.substr(0, this.src.lastIndexOf('/')) + '/';
                if (foundPath == '/') foundPath = '';
                return false;
              }
            }
          });
          if (foundPath !== false) {
            loadModuleScripts(modules, foundPath);
            return true;
          }
          return false;
        };
        if (!findScriptPathAndLoadModules()) {
          $(findScriptPathAndLoadModules);
        }
      }
    },
    /**
    * Validate the value of given element according to the validation rules
    * found in the attribute data-validation. Will return true if valid,
    * error message otherwise
    *
    * @param {jQuery} $elem
    * @param {Object} language ($.formUtils.LANG)
    * @param {Object} conf
    * @param {jQuery} $form
    * @param {String} [eventContext]
    * @return {String|Boolean}
    */
    validateInput: function validateInput($elem, language, conf, $form, eventContext) {
      if ($elem.attr('disabled')) return null; // returning null will prevent that the valid class gets applied to the element

      $elem.trigger('beforeValidation');
      var value = $.trim($elem.val() || ''),
        optional = $elem.valAttr('optional'),
        // test if a checkbox forces this element to be validated
        validationDependsOnCheckedInput = false,
        validationDependentInputIsChecked = false,
        validateIfCheckedElement = false,
        // get value of this element's attribute "... if-checked"
        validateIfCheckedElementName = $elem.valAttr("if-checked");

      // make sure we can proceed
      if (validateIfCheckedElementName != null) {
        // Set the boolean telling us that the validation depends
        // on another input being checked
        validationDependsOnCheckedInput = true;

        // select the checkbox type element in this form
        validateIfCheckedElement = $form.find('input[name="' + validateIfCheckedElementName + '"]');

        // test if it's property "checked" is checked
        if (validateIfCheckedElement.prop('checked')) {
          // set value for validation checkpoint
          validationDependentInputIsChecked = true;
        }
      }

      // validation checkpoint
      // if empty AND optional attribute is present
      // OR depending on a checkbox being checked AND checkbox is checked, return true
      if (!value && optional === 'true' || validationDependsOnCheckedInput && !validationDependentInputIsChecked) {
        return conf.addValidClassOnAll ? true : null;
      }
      var validationRules = $elem.attr(conf.validationRuleAttribute),
        // see if form element has inline err msg attribute
        validationErrorMsg = true;
      if (!validationRules) {
        return conf.addValidClassOnAll ? true : null;
      }
      $.split(validationRules, function (rule) {
        if (rule.indexOf('validate_') !== 0) {
          rule = 'validate_' + rule;
        }
        var validator = $.formUtils.validators[rule];
        if (validator && typeof validator['validatorFunction'] == 'function') {
          // special change of element for checkbox_group rule
          if (rule == 'validate_checkbox_group') {
            // set element to first in group, so error msg is set only once
            $elem = $("[name='" + $elem.attr('name') + "']:eq(0)");
          }
          var isValid = true;
          if (eventContext != 'keyup' || validator.validateOnKeyUp) {
            isValid = validator.validatorFunction(value, $elem, conf, language, $form);
          }
          if (!isValid) {
            validationErrorMsg = $elem.attr(conf.validationErrorMsgAttribute);
            if (!validationErrorMsg) {
              validationErrorMsg = language[validator.errorMessageKey];
              if (!validationErrorMsg) validationErrorMsg = validator.errorMessage;
            }
            return false; // breaks the iteration
          }
        } else {
          console.warn('Using undefined validator "' + rule + '"');
        }
      }, ' ');
      if (typeof validationErrorMsg == 'string') {
        return validationErrorMsg;
      } else {
        return true;
      }
    },
    /**
     * Is it a correct date according to given dateFormat. Will return false if not, otherwise
     * an array 0=>year 1=>month 2=>day
     *
     * @param {String} val
     * @param {String} dateFormat
     * @return {Array}|{Boolean}
     */
    parseDate: function parseDate(val, dateFormat) {
      var divider = dateFormat.replace(/[a-zA-Z]/gi, '').substring(0, 1),
        regexp = '^',
        formatParts = dateFormat.split(divider),
        matches,
        day,
        month,
        year;
      $.each(formatParts, function (i, part) {
        regexp += (i > 0 ? '\\' + divider : '') + '(\\d{' + part.length + '})';
      });
      regexp += '$';
      matches = val.match(new RegExp(regexp));
      if (matches === null) {
        return false;
      }
      var findDateUnit = function findDateUnit(unit, formatParts, matches) {
        for (var i = 0; i < formatParts.length; i++) {
          if (formatParts[i].substring(0, 1) === unit) {
            return $.formUtils.parseDateInt(matches[i + 1]);
          }
        }
        return -1;
      };
      month = findDateUnit('m', formatParts, matches);
      day = findDateUnit('d', formatParts, matches);
      year = findDateUnit('y', formatParts, matches);
      if (month === 2 && day > 28 && (year % 4 !== 0 || year % 100 === 0 && year % 400 !== 0) || month === 2 && day > 29 && (year % 4 === 0 || year % 100 !== 0 && year % 400 === 0) || month > 12 || month === 0) {
        return false;
      }
      if (this.isShortMonth(month) && day > 30 || !this.isShortMonth(month) && day > 31 || day === 0) {
        return false;
      }
      return [year, month, day];
    },
    /**
     * skum fix. är talet 05 eller lägre ger parseInt rätt int annars får man 0 när man kör parseInt?
     *
     * @param {String} val
     * @param {Number}
     */
    parseDateInt: function parseDateInt(val) {
      if (val.indexOf('0') === 0) {
        val = val.replace('0', '');
      }
      return parseInt(val, 10);
    },
    /**
    * Has month only 30 days?
    *
    * @param {Number} m
    * @return {Boolean}
    */
    isShortMonth: function isShortMonth(m) {
      return m % 2 === 0 && m < 7 || m % 2 !== 0 && m > 7;
    },
    /**
     * Restrict input length
     *
     * @param {jQuery} $inputElement Jquery Html object
     * @param {jQuery} $maxLengthElement jQuery Html Object
     * @return void
     */
    lengthRestriction: function lengthRestriction($inputElement, $maxLengthElement) {
      // read maxChars from counter display initial text value
      var maxChars = parseInt($maxLengthElement.text(), 10),
        charsLeft = 0,
        // internal function does the counting and sets display value
        countCharacters = function countCharacters() {
          var numChars = $inputElement.val().length;
          if (numChars > maxChars) {
            // get current scroll bar position
            var currScrollTopPos = $inputElement.scrollTop();
            // trim value to max length
            $inputElement.val($inputElement.val().substring(0, maxChars));
            $inputElement.scrollTop(currScrollTopPos);
          }
          charsLeft = maxChars - numChars;
          if (charsLeft < 0) charsLeft = 0;

          // set counter text
          $maxLengthElement.text(charsLeft);
        };

      // bind events to this element
      // setTimeout is needed, cut or paste fires before val is available
      $($inputElement).bind('keydown keyup keypress focus blur', countCharacters).bind('cut paste', function () {
        setTimeout(countCharacters, 100);
      });

      // count chars on pageload, if there are prefilled input-values
      $(document).bind("ready", countCharacters);
    },
    /**
    * Test numeric against allowed range
    *
    * @param $value int
    * @param $rangeAllowed str; (1-2, min1, max2)
    * @return array 
    */
    numericRangeCheck: function numericRangeCheck(value, rangeAllowed) {
      // split by dash
      var range = $.split(rangeAllowed, '-');
      // min or max
      var minmax = parseInt(rangeAllowed.substr(3), 10);
      // range ?
      if (range.length == 2 && (value < parseInt(range[0], 10) || value > parseInt(range[1], 10))) {
        return ["out", range[0], range[1]];
      } // value is out of range
      else if (rangeAllowed.indexOf('min') === 0 && value < minmax)
        // min
        {
          return ["min", minmax];
        } // value is below min
      else if (rangeAllowed.indexOf('max') === 0 && value > minmax)
        // max
        {
          return ["max", minmax];
        } // value is above max
      else {
        return ["ok"];
      } // value is in allowed range
    },
    _numSuggestionElements: 0,
    _selectedSuggestion: null,
    _previousTypedVal: null,
    /**
     * Utility function that can be used to create plugins that gives
     * suggestions when inputs is typed into
     * @param {jQuery} $elem
     * @param {Array} suggestions
     * @param {Object} settings - Optional
     * @return {jQuery}
     */
    suggest: function suggest($elem, suggestions, settings) {
      var conf = {
          css: {
            maxHeight: '150px',
            background: '#FFF',
            lineHeight: '150%',
            textDecoration: 'underline',
            overflowX: 'hidden',
            overflowY: 'auto',
            border: '#CCC solid 1px',
            borderTop: 'none',
            cursor: 'pointer'
          },
          activeSuggestionCSS: {
            background: '#E9E9E9'
          }
        },
        setSuggsetionPosition = function setSuggsetionPosition($suggestionContainer, $input) {
          var offset = $input.offset();
          $suggestionContainer.css({
            width: $input.outerWidth(),
            left: offset.left + 'px',
            top: offset.top + $input.outerHeight() + 'px'
          });
        };
      if (settings) $.extend(conf, settings);
      conf.css['position'] = 'absolute';
      conf.css['z-index'] = 9999;
      $elem.attr('autocomplete', 'off');
      if (this._numSuggestionElements === 0) {
        // Re-position suggestion container if window size changes
        $(window).bind('resize', function () {
          $('.jquery-form-suggestions').each(function () {
            var $container = $(this),
              suggestID = $container.attr('data-suggest-container');
            setSuggsetionPosition($container, $('.suggestions-' + suggestID).eq(0));
          });
        });
      }
      this._numSuggestionElements++;
      var onSelectSuggestion = function onSelectSuggestion($el) {
        var suggestionId = $el.valAttr('suggestion-nr');
        $.formUtils._selectedSuggestion = null;
        $.formUtils._previousTypedVal = null;
        $('.jquery-form-suggestion-' + suggestionId).fadeOut('fast');
      };
      $elem.data('suggestions', suggestions).valAttr('suggestion-nr', this._numSuggestionElements).unbind('focus.suggest').bind('focus.suggest', function () {
        $(this).trigger('keyup');
        $.formUtils._selectedSuggestion = null;
      }).unbind('keyup.suggest').bind('keyup.suggest', function () {
        var $input = $(this),
          foundSuggestions = [],
          val = $.trim($input.val()).toLocaleLowerCase();
        if (val == $.formUtils._previousTypedVal) {
          return;
        } else {
          $.formUtils._previousTypedVal = val;
        }
        var hasTypedSuggestion = false,
          suggestionId = $input.valAttr('suggestion-nr'),
          $suggestionContainer = $('.jquery-form-suggestion-' + suggestionId);
        $suggestionContainer.scrollTop(0);

        // Find the right suggestions
        if (val != '') {
          var findPartial = val.length > 2;
          $.each($input.data('suggestions'), function (i, suggestion) {
            var lowerCaseVal = suggestion.toLocaleLowerCase();
            if (lowerCaseVal == val) {
              foundSuggestions.push('<strong>' + suggestion + '</strong>');
              hasTypedSuggestion = true;
              return false;
            } else if (lowerCaseVal.indexOf(val) === 0 || findPartial && lowerCaseVal.indexOf(val) > -1) {
              foundSuggestions.push(suggestion.replace(new RegExp(val, 'gi'), '<strong>$&</strong>'));
            }
          });
        }

        // Hide suggestion container
        if (hasTypedSuggestion || foundSuggestions.length == 0 && $suggestionContainer.length > 0) {
          $suggestionContainer.hide();
        }

        // Create suggestion container if not already exists
        else if (foundSuggestions.length > 0 && $suggestionContainer.length == 0) {
          $suggestionContainer = $('<div></div>').css(conf.css).appendTo('body');
          $elem.addClass('suggestions-' + suggestionId);
          $suggestionContainer.attr('data-suggest-container', suggestionId).addClass('jquery-form-suggestions').addClass('jquery-form-suggestion-' + suggestionId);
        }

        // Show hidden container
        else if (foundSuggestions.length > 0 && !$suggestionContainer.is(':visible')) {
          $suggestionContainer.show();
        }

        // add suggestions
        if (foundSuggestions.length > 0 && val.length != foundSuggestions[0].length) {
          // put container in place every time, just in case
          setSuggsetionPosition($suggestionContainer, $input);

          // Add suggestions HTML to container
          $suggestionContainer.html('');
          $.each(foundSuggestions, function (i, text) {
            $('<div></div>').append(text).css({
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              padding: '5px'
            }).addClass('form-suggest-element').appendTo($suggestionContainer).click(function () {
              $input.focus();
              $input.val($(this).text());
              onSelectSuggestion($input);
            });
          });
        }
      }).unbind('keydown.validation').bind('keydown.validation', function (e) {
        var code = e.keyCode ? e.keyCode : e.which,
          suggestionId,
          $suggestionContainer,
          $input = $(this);
        if (code == 13 && $.formUtils._selectedSuggestion !== null) {
          suggestionId = $input.valAttr('suggestion-nr');
          $suggestionContainer = $('.jquery-form-suggestion-' + suggestionId);
          if ($suggestionContainer.length > 0) {
            var newText = $suggestionContainer.find('div').eq($.formUtils._selectedSuggestion).text();
            $input.val(newText);
            onSelectSuggestion($input);
            e.preventDefault();
          }
        } else {
          suggestionId = $input.valAttr('suggestion-nr');
          $suggestionContainer = $('.jquery-form-suggestion-' + suggestionId);
          var $suggestions = $suggestionContainer.children();
          if ($suggestions.length > 0 && $.inArray(code, [38, 40]) > -1) {
            if (code == 38) {
              // key up
              if ($.formUtils._selectedSuggestion === null) $.formUtils._selectedSuggestion = $suggestions.length - 1;else $.formUtils._selectedSuggestion--;
              if ($.formUtils._selectedSuggestion < 0) $.formUtils._selectedSuggestion = $suggestions.length - 1;
            } else if (code == 40) {
              // key down
              if ($.formUtils._selectedSuggestion === null) $.formUtils._selectedSuggestion = 0;else $.formUtils._selectedSuggestion++;
              if ($.formUtils._selectedSuggestion > $suggestions.length - 1) $.formUtils._selectedSuggestion = 0;
            }

            // Scroll in suggestion window
            var containerInnerHeight = $suggestionContainer.innerHeight(),
              containerScrollTop = $suggestionContainer.scrollTop(),
              suggestionHeight = $suggestionContainer.children().eq(0).outerHeight(),
              activeSuggestionPosY = suggestionHeight * $.formUtils._selectedSuggestion;
            if (activeSuggestionPosY < containerScrollTop || activeSuggestionPosY > containerScrollTop + containerInnerHeight) {
              $suggestionContainer.scrollTop(activeSuggestionPosY);
            }
            $suggestions.removeClass('active-suggestion').css('background', 'none').eq($.formUtils._selectedSuggestion).addClass('active-suggestion').css(conf.activeSuggestionCSS);
            e.preventDefault();
            return false;
          }
        }
      }).unbind('blur.suggest').bind('blur.suggest', function () {
        onSelectSuggestion($(this));
      });
      return $elem;
    },
    /**
     * Error dialogs
     *
     * @var {Object}
     */
    LANG: {
      errorTitle: 'Form submission failed!',
      requiredFields: 'You have not answered all required fields',
      badTime: 'You have not given a correct time',
      badEmail: 'You have not given a correct e-mail address',
      badTelephone: 'You have not given a correct phone number',
      badSecurityAnswer: 'You have not given a correct answer to the security question',
      badDate: 'You have not given a correct date',
      lengthBadStart: 'You must give an answer between ',
      lengthBadEnd: ' characters',
      lengthTooLongStart: 'You have given an answer longer than ',
      lengthTooShortStart: 'You have given an answer shorter than ',
      notConfirmed: 'Values could not be confirmed',
      badDomain: 'Incorrect domain value',
      badUrl: 'The answer you gave was not a correct URL',
      badCustomVal: 'You gave an incorrect answer',
      badInt: 'The answer you gave was not a correct number',
      badSecurityNumber: 'Your social security number was incorrect',
      badUKVatAnswer: 'Incorrect UK VAT Number',
      badStrength: 'The password isn\'t strong enough',
      badNumberOfSelectedOptionsStart: 'You have to choose at least ',
      badNumberOfSelectedOptionsEnd: ' answers',
      badAlphaNumeric: 'The answer you gave must contain only alphanumeric characters ',
      badAlphaNumericExtra: ' and ',
      wrongFileSize: 'The file you are trying to upload is too large',
      wrongFileType: 'The file you are trying to upload is of wrong type',
      groupCheckedRangeStart: 'Please choose between ',
      groupCheckedTooFewStart: 'Please choose at least ',
      groupCheckedTooManyStart: 'Please choose a maximum of ',
      groupCheckedEnd: ' item(s)'
    }
  };

  /* * * * * * * * * * * * * * * * * * * * * *
    CORE VALIDATORS
  * * * * * * * * * * * * * * * * * * * * */

  /*
  * Validate email
  */
  $.formUtils.addValidator({
    name: 'email',
    validatorFunction: function validatorFunction(email) {
      var emailParts = email.toLowerCase().split('@');
      if (emailParts.length == 2) {
        return $.formUtils.validators.validate_domain.validatorFunction(emailParts[1]) && !/[^\w\+\.\-]/.test(emailParts[0]);
      }
      return false;
    },
    errorMessage: '',
    errorMessageKey: 'badEmail'
  });

  /*
  * Validate domain name
  */
  $.formUtils.addValidator({
    name: 'domain',
    validatorFunction: function validatorFunction(val, $input) {
      var topDomains = ['.ac', '.ad', '.ae', '.aero', '.af', '.ag', '.ai', '.al', '.am', '.an', '.ao', '.aq', '.ar', '.arpa', '.as', '.asia', '.at', '.au', '.aw', '.ax', '.az', '.ba', '.bb', '.bd', '.be', '.bf', '.bg', '.bh', '.bi', '.bike', '.biz', '.bj', '.bm', '.bn', '.bo', '.br', '.bs', '.bt', '.bv', '.bw', '.by', '.bz', '.ca', '.camera', '.cat', '.cc', '.cd', '.cf', '.cg', '.ch', '.ci', '.ck', '.cl', '.clothing', '.cm', '.cn', '.co', '.com', '.construction', '.contractors', '.coop', '.cr', '.cu', '.cv', '.cw', '.cx', '.cy', '.cz', '.de', '.diamonds', '.directory', '.dj', '.dk', '.dm', '.do', '.dz', '.ec', '.edu', '.ee', '.eg', '.enterprises', '.equipment', '.er', '.es', '.estate', '.et', '.eu', '.fi', '.fj', '.fk', '.fm', '.fo', '.fr', '.ga', '.gallery', '.gb', '.gd', '.ge', '.gf', '.gg', '.gh', '.gi', '.gl', '.gm', '.gn', '.gov', '.gp', '.gq', '.gr', '.graphics', '.gs', '.gt', '.gu', '.guru', '.gw', '.gy', '.hk', '.hm', '.hn', '.holdings', '.hr', '.ht', '.hu', '.id', '.ie', '.il', '.im', '.in', '.info', '.int', '.io', '.iq', '.ir', '.is', '.it', '.je', '.jm', '.jo', '.jobs', '.jp', '.ke', '.kg', '.kh', '.ki', '.kitchen', '.km', '.kn', '.kp', '.kr', '.kw', '.ky', '.kz', '.la', '.land', '.lb', '.lc', '.li', '.lighting', '.lk', '.lr', '.ls', '.lt', '.lu', '.lv', '.ly', '.ma', '.mc', '.md', '.me', '.menu', '.mg', '.mh', '.mil', '.mk', '.ml', '.mm', '.mn', '.mo', '.mobi', '.mp', '.mq', '.mr', '.ms', '.mt', '.mu', '.museum', '.mv', '.mw', '.mx', '.my', '.mz', '.na', '.name', '.nc', '.ne', '.net', '.nf', '.ng', '.ni', '.nl', '.no', '.np', '.nr', '.nu', '.nz', '.om', '.org', '.pa', '.pe', '.pf', '.pg', '.ph', '.photography', '.pk', '.pl', '.plumbing', '.pm', '.pn', '.post', '.pr', '.pro', '.ps', '.pt', '.pw', '.py', '.qa', '.re', '.ro', '.rs', '.ru', '.rw', '.sa', '.sb', '.sc', '.sd', '.se', '.sexy', '.sg', '.sh', '.si', '.singles', '.sj', '.sk', '.sl', '.sm', '.sn', '.so', '.sr', '.st', '.su', '.sv', '.sx', '.sy', '.sz', '.tattoo', '.tc', '.td', '.technology', '.tel', '.tf', '.tg', '.th', '.tips', '.tj', '.tk', '.tl', '.tm', '.tn', '.to', '.today', '.tp', '.tr', '.travel', '.tt', '.tv', '.tw', '.tz', '.ua', '.ug', '.uk', '.uno', '.us', '.uy', '.uz', '.va', '.vc', '.ve', '.ventures', '.vg', '.vi', '.vn', '.voyage', '.vu', '.wf', '.ws', '.xn--3e0b707e', '.xn--45brj9c', '.xn--80ao21a', '.xn--80asehdb', '.xn--80aswg', '.xn--90a3ac', '.xn--clchc0ea0b2g2a9gcd', '.xn--fiqs8s', '.xn--fiqz9s', '.xn--fpcrj9c3d', '.xn--fzc2c9e2c', '.xn--gecrj9c', '.xn--h2brj9c', '.xn--j1amh', '.xn--j6w193g', '.xn--kprw13d', '.xn--kpry57d', '.xn--l1acc', '.xn--lgbbat1ad8j', '.xn--mgb9awbf', '.xn--mgba3a4f16a', '.xn--mgbaam7a8h', '.xn--mgbayh7gpa', '.xn--mgbbh1a71e', '.xn--mgbc0a9azcg', '.xn--mgberp4a5d4ar', '.xn--mgbx4cd0ab', '.xn--ngbc5azd', '.xn--o3cw4h', '.xn--ogbpf8fl', '.xn--p1ai', '.xn--pgbs0dh', '.xn--q9jyb4c', '.xn--s9brj9c', '.xn--unup4y', '.xn--wgbh1c', '.xn--wgbl6a', '.xn--xkc2al3hye2a', '.xn--xkc2dl3a5ee0h', '.xn--yfro4i67o', '.xn--ygbi2ammx', '.xxx', '.ye', '.yt', '.za', '.zm', '.zw'],
        ukTopDomains = ['co', 'me', 'ac', 'gov', 'judiciary', 'ltd', 'mod', 'net', 'nhs', 'nic', 'org', 'parliament', 'plc', 'police', 'sch', 'bl', 'british-library', 'jet', 'nls'],
        dot = val.lastIndexOf('.'),
        domain = val.substring(0, dot),
        ext = val.substring(dot, val.length),
        hasTopDomain = false;
      for (var i = 0; i < topDomains.length; i++) {
        if (topDomains[i] === ext) {
          if (ext === '.uk') {
            //Run Extra Checks for UK Domain Names
            var domainParts = val.split('.');
            var tld2 = domainParts[domainParts.length - 2];
            for (var j = 0; j < ukTopDomains.length; j++) {
              if (ukTopDomains[j] === tld2) {
                hasTopDomain = true;
                break;
              }
            }
            if (hasTopDomain) break;
          } else {
            hasTopDomain = true;
            break;
          }
        }
      }
      if (!hasTopDomain) {
        return false;
      } else if (dot < 2 || dot > 57) {
        return false;
      } else {
        var firstChar = domain.substring(0, 1),
          lastChar = domain.substring(domain.length - 1, domain.length);
        if (firstChar === '-' || firstChar === '.' || lastChar === '-' || lastChar === '.') {
          return false;
        }
        if (domain.split('.').length > 3 || domain.split('..').length > 1) {
          return false;
        }
        if (domain.replace(/[-\da-z\.]/g, '') !== '') {
          return false;
        }
      }

      // It's valid, lets update input with trimmed value perhaps??
      if (typeof $input !== 'undefined') {
        $input.val(val);
      }
      return true;
    },
    errorMessage: '',
    errorMessageKey: 'badDomain'
  });

  /*
  * Validate required
  */
  $.formUtils.addValidator({
    name: 'required',
    validatorFunction: function validatorFunction(val, $el) {
      return $el.attr('type') == 'checkbox' ? $el.is(':checked') : $.trim(val) !== '';
    },
    errorMessage: '',
    errorMessageKey: 'requiredFields'
  });

  /*
  * Validate length range
  */
  $.formUtils.addValidator({
    name: 'length',
    validatorFunction: function validatorFunction(val, $el, conf, lang) {
      var lengthAllowed = $el.valAttr('length'),
        type = $el.attr('type');
      if (lengthAllowed == undefined) {
        var elementType = $el.get(0).nodeName;
        alert('Please add attribute "data-validation-length" to ' + elementType + ' named ' + $el.attr('name'));
        return true;
      }

      // check if length is above min, below max or within range.
      var len = type == 'file' && $el.get(0).files !== undefined ? $el.get(0).files.length : val.length,
        lengthCheckResults = $.formUtils.numericRangeCheck(len, lengthAllowed),
        checkResult;
      switch (lengthCheckResults[0]) {
        // outside of allowed range
        case "out":
          this.errorMessage = lang.lengthBadStart + lengthAllowed + lang.lengthBadEnd;
          checkResult = false;
          break;
        // too short
        case "min":
          this.errorMessage = lang.lengthTooShortStart + lengthCheckResults[1] + lang.lengthBadEnd;
          checkResult = false;
          break;
        // too long
        case "max":
          this.errorMessage = lang.lengthTooLongStart + lengthCheckResults[1] + lang.lengthBadEnd;
          checkResult = false;
          break;
        // ok
        default:
          checkResult = true;
      }
      return checkResult;
    },
    errorMessage: '',
    errorMessageKey: ''
  });

  /*
  * Validate url
  */
  $.formUtils.addValidator({
    name: 'url',
    validatorFunction: function validatorFunction(url) {
      // written by Scott Gonzalez: http://projects.scottsplayground.com/iri/
      // - Victor Jonsson added support for arrays in the url ?arg[]=sdfsdf
      // - General improvements made by Stéphane Moureau <https://github.com/TraderStf>
      var urlFilter = /^(https?|ftp):\/\/((((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])(\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])(\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/(((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|\[|\]|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#(((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
      if (urlFilter.test(url)) {
        var domain = url.split('://')[1];
        var domainSlashPos = domain.indexOf('/');
        if (domainSlashPos > -1) domain = domain.substr(0, domainSlashPos);
        return $.formUtils.validators.validate_domain.validatorFunction(domain); // todo: add support for IP-addresses
      }
      return false;
    },
    errorMessage: '',
    errorMessageKey: 'badUrl'
  });

  /*
  * Validate number (floating or integer)
  */
  $.formUtils.addValidator({
    name: 'number',
    validatorFunction: function validatorFunction(val, $el, conf) {
      if (val !== '') {
        var allowing = $el.valAttr('allowing') || '',
          decimalSeparator = $el.valAttr('decimal-separator') || conf.decimalSeparator,
          allowsRange = false,
          begin,
          end;
        if (allowing.indexOf('number') == -1) allowing += ',number';
        if (allowing.indexOf('negative') > -1 && val.indexOf('-') === 0) {
          val = val.substr(1);
        }
        if (allowing.indexOf('range') > -1) {
          begin = parseFloat(allowing.substring(allowing.indexOf("[") + 1, allowing.indexOf(";")));
          end = parseFloat(allowing.substring(allowing.indexOf(";") + 1, allowing.indexOf("]")));
          allowsRange = true;
        }
        if (decimalSeparator == ',') {
          // Fix for checking range with floats using ,
          val = val.replace(',', '.');
        }
        if (allowing.indexOf('number') > -1 && val.replace(/[0-9]/g, '') === '' && (!allowsRange || val >= begin && val <= end)) {
          return true;
        }
        if (allowing.indexOf('float') > -1 && val.match(new RegExp('^([0-9]+)\\.([0-9]+)$')) !== null && (!allowsRange || val >= begin && val <= end)) {
          return true;
        }
      }
      return false;
    },
    errorMessage: '',
    errorMessageKey: 'badInt'
  });

  /*
   * Validate alpha numeric
   */
  $.formUtils.addValidator({
    name: 'alphanumeric',
    validatorFunction: function validatorFunction(val, $el, conf, language) {
      var patternStart = '^([a-zA-Z0-9',
        patternEnd = ']+)$',
        additionalChars = $el.attr('data-validation-allowing'),
        pattern = '';
      if (additionalChars) {
        pattern = patternStart + additionalChars + patternEnd;
        var extra = additionalChars.replace(/\\/g, '');
        if (extra.indexOf(' ') > -1) {
          extra = extra.replace(' ', '');
          extra += ' and spaces ';
        }
        this.errorMessage = language.badAlphaNumeric + language.badAlphaNumericExtra + extra;
      } else {
        pattern = patternStart + patternEnd;
        this.errorMessage = language.badAlphaNumeric;
      }
      return new RegExp(pattern).test(val);
    },
    errorMessage: '',
    errorMessageKey: ''
  });

  /*
  * Validate against regexp
  */
  $.formUtils.addValidator({
    name: 'custom',
    validatorFunction: function validatorFunction(val, $el, conf) {
      var regexp = new RegExp($el.valAttr('regexp'));
      return regexp.test(val);
    },
    errorMessage: '',
    errorMessageKey: 'badCustomVal'
  });

  /*
  * Validate date
  */
  $.formUtils.addValidator({
    name: 'date',
    validatorFunction: function validatorFunction(date, $el, conf) {
      var dateFormat = 'yyyy-mm-dd';
      if ($el.valAttr('format')) {
        dateFormat = $el.valAttr('format');
      } else if (conf.dateFormat) {
        dateFormat = conf.dateFormat;
      }
      return $.formUtils.parseDate(date, dateFormat) !== false;
    },
    errorMessage: '',
    errorMessageKey: 'badDate'
  });

  /*
  * Validate group of checkboxes, validate qty required is checked
  * written by Steve Wasiura : http://stevewasiura.waztech.com
  * element attrs
  *    data-validation="checkbox_group"
  *    data-validation-qty="1-2"  // min 1 max 2
  *    data-validation-error-msg="chose min 1, max of 2 checkboxes"
  */
  $.formUtils.addValidator({
    name: 'checkbox_group',
    validatorFunction: function validatorFunction(val, $el, conf, lang, $form) {
      // preset return var
      var checkResult = true;
      // get name of element. since it is a checkbox group, all checkboxes will have same name
      var elname = $el.attr('name');
      // get count of checked checkboxes with this name
      var checkedCount = $("input[type=checkbox][name^='" + elname + "']:checked", $form).length;
      // get el attr that specs qty required / allowed
      var qtyAllowed = $el.valAttr('qty');
      if (qtyAllowed == undefined) {
        var elementType = $el.get(0).nodeName;
        alert('Attribute "data-validation-qty" is missing from ' + elementType + ' named ' + $el.attr('name'));
      }
      // call Utility function to check if count is above min, below max, within range etc.
      var qtyCheckResults = $.formUtils.numericRangeCheck(checkedCount, qtyAllowed);
      // results will be array, [0]=result str, [1]=qty int
      switch (qtyCheckResults[0]) {
        // outside allowed range
        case "out":
          this.errorMessage = lang.groupCheckedRangeStart + qtyAllowed + lang.groupCheckedEnd;
          checkResult = false;
          break;
        // below min qty
        case "min":
          this.errorMessage = lang.groupCheckedTooFewStart + qtyCheckResults[1] + lang.groupCheckedEnd;
          checkResult = false;
          break;
        // above max qty
        case "max":
          this.errorMessage = lang.groupCheckedTooManyStart + qtyCheckResults[1] + lang.groupCheckedEnd;
          checkResult = false;
          break;
        // ok
        default:
          checkResult = true;
      }
      return checkResult;
    }
    //   errorMessage : '', // set above in switch statement
    //   errorMessageKey: '' // not used
  });
})(jQuery);

/*!
 * jQuery Form Plugin
 * version: 4.3.0
 * Requires jQuery v1.7.2 or later
 * Project repository: https://github.com/jquery-form/form

 * Copyright 2017 Kevin Morris
 * Copyright 2006 M. Alsup

 * Dual licensed under the LGPL-2.1+ or MIT licenses
 * https://github.com/jquery-form/form#license

 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 */
/* global ActiveXObject */

/* eslint-disable */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = function (root, jQuery) {
      if (typeof jQuery === 'undefined') {
        // require('jQuery') returns a factory that requires window to build a jQuery instance, we normalize how we use modules
        // that require this pattern but the window provided is a noop if it's defined (how jquery works)
        if (typeof window !== 'undefined') {
          jQuery = require('jquery');
        } else {
          jQuery = require('jquery')(root);
        }
      }
      factory(jQuery);
      return jQuery;
    };
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  /* eslint-enable */
  'use strict';

  /*
  	Usage Note:
  	-----------
  	Do not use both ajaxSubmit and ajaxForm on the same form. These
  	functions are mutually exclusive. Use ajaxSubmit if you want
  	to bind your own submit handler to the form. For example,
  		$(document).ready(function() {
  		$('#myForm').on('submit', function(e) {
  			e.preventDefault(); // <-- important
  			$(this).ajaxSubmit({
  				target: '#output'
  			});
  		});
  	});
  		Use ajaxForm when you want the plugin to manage all the event binding
  	for you. For example,
  		$(document).ready(function() {
  		$('#myForm').ajaxForm({
  			target: '#output'
  		});
  	});
  		You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
  	form does not have to exist when you invoke ajaxForm:
  		$('#myForm').ajaxForm({
  		delegation: true,
  		target: '#output'
  	});
  		When using ajaxForm, the ajaxSubmit function will be invoked for you
  	at the appropriate time.
  */
  var rCRLF = /\r?\n/g;

  /**
   * Feature detection
   */
  var feature = {};
  feature.fileapi = $('<input type="file">').get(0).files !== undefined;
  feature.formdata = typeof window.FormData !== 'undefined';
  var hasProp = !!$.fn.prop;

  // attr2 uses prop when it can but checks the return type for
  // an expected string. This accounts for the case where a form
  // contains inputs with names like "action" or "method"; in those
  // cases "prop" returns the element
  $.fn.attr2 = function () {
    if (!hasProp) {
      return this.attr.apply(this, arguments);
    }
    var val = this.prop.apply(this, arguments);
    if (val && val.jquery || typeof val === 'string') {
      return val;
    }
    return this.attr.apply(this, arguments);
  };

  /**
   * ajaxSubmit() provides a mechanism for immediately submitting
   * an HTML form using AJAX.
   *
   * @param	{object|string}	options		jquery.form.js parameters or custom url for submission
   * @param	{object}		data		extraData
   * @param	{string}		dataType	ajax dataType
   * @param	{function}		onSuccess	ajax success callback function
   */
  $.fn.ajaxSubmit = function (options, data, dataType, onSuccess) {
    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
    if (!this.length) {
      log('ajaxSubmit: skipping submit process - no element selected');
      return this;
    }

    /* eslint consistent-this: ["error", "$form"] */
    var method,
      action,
      url,
      isMsie,
      iframeSrc,
      $form = this;
    if (typeof options === 'function') {
      options = {
        success: options
      };
    } else if (typeof options === 'string' || options === false && arguments.length > 0) {
      options = {
        'url': options,
        'data': data,
        'dataType': dataType
      };
      if (typeof onSuccess === 'function') {
        options.success = onSuccess;
      }
    } else if (typeof options === 'undefined') {
      options = {};
    }
    method = options.method || options.type || this.attr2('method');
    action = options.url || this.attr2('action');
    url = typeof action === 'string' ? $.trim(action) : '';
    url = url || window.location.href || '';
    if (url) {
      // clean url (don't include hash vaue)
      url = (url.match(/^([^#]+)/) || [])[1];
    }
    // IE requires javascript:false in https, but this breaks chrome >83 and goes against spec.
    // Instead of using javascript:false always, let's only apply it for IE.
    isMsie = /(MSIE|Trident)/.test(navigator.userAgent || '');
    iframeSrc = isMsie && /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'; // eslint-disable-line no-script-url

    options = $.extend(true, {
      url: url,
      success: $.ajaxSettings.success,
      type: method || $.ajaxSettings.type,
      iframeSrc: iframeSrc
    }, options);

    // hook for manipulating the form data before it is extracted;
    // convenient for use with rich editors like tinyMCE or FCKEditor
    var veto = {};
    this.trigger('form-pre-serialize', [this, options, veto]);
    if (veto.veto) {
      log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
      return this;
    }

    // provide opportunity to alter form data before it is serialized
    if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
      log('ajaxSubmit: submit aborted via beforeSerialize callback');
      return this;
    }
    var traditional = options.traditional;
    if (typeof traditional === 'undefined') {
      traditional = $.ajaxSettings.traditional;
    }
    var elements = [];
    var qx,
      a = this.formToArray(options.semantic, elements, options.filtering);
    if (options.data) {
      var optionsData = $.isFunction(options.data) ? options.data(a) : options.data;
      options.extraData = optionsData;
      qx = $.param(optionsData, traditional);
    }

    // give pre-submit callback an opportunity to abort the submit
    if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
      log('ajaxSubmit: submit aborted via beforeSubmit callback');
      return this;
    }

    // fire vetoable 'validate' event
    this.trigger('form-submit-validate', [a, this, options, veto]);
    if (veto.veto) {
      log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
      return this;
    }
    var q = $.param(a, traditional);
    if (qx) {
      q = q ? q + '&' + qx : qx;
    }
    if (options.type.toUpperCase() === 'GET') {
      options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
      options.data = null; // data is null for 'get'
    } else {
      options.data = q; // data is the query string for 'post'
    }
    var callbacks = [];
    if (options.resetForm) {
      callbacks.push(function () {
        $form.resetForm();
      });
    }
    if (options.clearForm) {
      callbacks.push(function () {
        $form.clearForm(options.includeHidden);
      });
    }

    // perform a load on the target only if dataType is not provided
    if (!options.dataType && options.target) {
      var oldSuccess = options.success || function () {};
      callbacks.push(function (data, textStatus, jqXHR) {
        var successArguments = arguments,
          fn = options.replaceTarget ? 'replaceWith' : 'html';
        $(options.target)[fn](data).each(function () {
          oldSuccess.apply(this, successArguments);
        });
      });
    } else if (options.success) {
      if ($.isArray(options.success)) {
        $.merge(callbacks, options.success);
      } else {
        callbacks.push(options.success);
      }
    }
    options.success = function (data, status, xhr) {
      // jQuery 1.4+ passes xhr as 3rd arg
      var context = options.context || this; // jQuery 1.4+ supports scope context

      for (var i = 0, max = callbacks.length; i < max; i++) {
        callbacks[i].apply(context, [data, status, xhr || $form, $form]);
      }
    };
    if (options.error) {
      var oldError = options.error;
      options.error = function (xhr, status, error) {
        var context = options.context || this;
        oldError.apply(context, [xhr, status, error, $form]);
      };
    }
    if (options.complete) {
      var oldComplete = options.complete;
      options.complete = function (xhr, status) {
        var context = options.context || this;
        oldComplete.apply(context, [xhr, status, $form]);
      };
    }

    // are there files to upload?

    // [value] (issue #113), also see comment:
    // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
    var fileInputs = $('input[type=file]:enabled', this).filter(function () {
      return $(this).val() !== '';
    });
    var hasFileInputs = fileInputs.length > 0;
    var mp = 'multipart/form-data';
    var multipart = $form.attr('enctype') === mp || $form.attr('encoding') === mp;
    var fileAPI = feature.fileapi && feature.formdata;
    log('fileAPI :' + fileAPI);
    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;
    var jqxhr;

    // options.iframe allows user to force iframe mode
    // 06-NOV-09: now defaulting to iframe mode if file input is detected
    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
      // hack to fix Safari hang (thanks to Tim Molendijk for this)
      // see: http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
      if (options.closeKeepAlive) {
        $.get(options.closeKeepAlive, function () {
          jqxhr = fileUploadIframe(a);
        });
      } else {
        jqxhr = fileUploadIframe(a);
      }
    } else if ((hasFileInputs || multipart) && fileAPI) {
      jqxhr = fileUploadXhr(a);
    } else {
      jqxhr = $.ajax(options);
    }
    $form.removeData('jqxhr').data('jqxhr', jqxhr);

    // clear element array
    for (var k = 0; k < elements.length; k++) {
      elements[k] = null;
    }

    // fire 'notify' event
    this.trigger('form-submit-notify', [this, options]);
    return this;

    // utility fn for deep serialization
    function deepSerialize(extraData) {
      var serialized = $.param(extraData, options.traditional).split('&');
      var len = serialized.length;
      var result = [];
      var i, part;
      for (i = 0; i < len; i++) {
        // #252; undo param space replacement
        serialized[i] = serialized[i].replace(/\+/g, ' ');
        part = serialized[i].split('=');
        // #278; use array instead of object storage, favoring array serializations
        result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
      }
      return result;
    }

    // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
    function fileUploadXhr(a) {
      var formdata = new FormData();
      for (var i = 0; i < a.length; i++) {
        formdata.append(a[i].name, a[i].value);
      }
      if (options.extraData) {
        var serializedData = deepSerialize(options.extraData);
        for (i = 0; i < serializedData.length; i++) {
          if (serializedData[i]) {
            formdata.append(serializedData[i][0], serializedData[i][1]);
          }
        }
      }
      options.data = null;
      var s = $.extend(true, {}, $.ajaxSettings, options, {
        contentType: false,
        processData: false,
        cache: false,
        type: method || 'POST'
      });
      if (options.uploadProgress) {
        // workaround because jqXHR does not expose upload property
        s.xhr = function () {
          var xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            xhr.upload.addEventListener('progress', function (event) {
              var percent = 0;
              var position = event.loaded || event.position; /* event.position is deprecated */
              var total = event.total;
              if (event.lengthComputable) {
                percent = Math.ceil(position / total * 100);
              }
              options.uploadProgress(event, position, total, percent);
            }, false);
          }
          return xhr;
        };
      }
      s.data = null;
      var beforeSend = s.beforeSend;
      s.beforeSend = function (xhr, o) {
        // Send FormData() provided by user
        if (options.formData) {
          o.data = options.formData;
        } else {
          o.data = formdata;
        }
        if (beforeSend) {
          beforeSend.call(this, xhr, o);
        }
      };
      return $.ajax(s);
    }

    // private function for handling file uploads (hat tip to YAHOO!)
    function fileUploadIframe(a) {
      var form = $form[0],
        el,
        i,
        s,
        g,
        id,
        $io,
        io,
        xhr,
        sub,
        n,
        timedOut,
        timeoutHandle;
      var deferred = $.Deferred();

      // #341
      deferred.abort = function (status) {
        xhr.abort(status);
      };
      if (a) {
        // ensure that every serialized input is still enabled
        for (i = 0; i < elements.length; i++) {
          el = $(elements[i]);
          if (hasProp) {
            el.prop('disabled', false);
          } else {
            el.removeAttr('disabled');
          }
        }
      }
      s = $.extend(true, {}, $.ajaxSettings, options);
      s.context = s.context || s;
      id = 'jqFormIO' + new Date().getTime();
      var ownerDocument = form.ownerDocument;
      var $body = $form.closest('body');
      if (s.iframeTarget) {
        $io = $(s.iframeTarget, ownerDocument);
        n = $io.attr2('name');
        if (!n) {
          $io.attr2('name', id);
        } else {
          id = n;
        }
      } else {
        $io = $('<iframe name="' + id + '" src="' + s.iframeSrc + '" />', ownerDocument);
        $io.css({
          position: 'absolute',
          top: '-1000px',
          left: '-1000px'
        });
      }
      io = $io[0];
      xhr = {
        // mock object
        aborted: 0,
        responseText: null,
        responseXML: null,
        status: 0,
        statusText: 'n/a',
        getAllResponseHeaders: function getAllResponseHeaders() {},
        getResponseHeader: function getResponseHeader() {},
        setRequestHeader: function setRequestHeader() {},
        abort: function abort(status) {
          var e = status === 'timeout' ? 'timeout' : 'aborted';
          log('aborting upload... ' + e);
          this.aborted = 1;
          try {
            // #214, #257
            if (io.contentWindow.document.execCommand) {
              io.contentWindow.document.execCommand('Stop');
            }
          } catch (ignore) {}
          $io.attr('src', s.iframeSrc); // abort op in progress
          xhr.error = e;
          if (s.error) {
            s.error.call(s.context, xhr, e, status);
          }
          if (g) {
            $.event.trigger('ajaxError', [xhr, s, e]);
          }
          if (s.complete) {
            s.complete.call(s.context, xhr, e);
          }
        }
      };
      g = s.global;
      // trigger ajax global events so that activity/block indicators work like normal
      if (g && $.active++ === 0) {
        $.event.trigger('ajaxStart');
      }
      if (g) {
        $.event.trigger('ajaxSend', [xhr, s]);
      }
      if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
        if (s.global) {
          $.active--;
        }
        deferred.reject();
        return deferred;
      }
      if (xhr.aborted) {
        deferred.reject();
        return deferred;
      }

      // add submitting element to data if we know it
      sub = form.clk;
      if (sub) {
        n = sub.name;
        if (n && !sub.disabled) {
          s.extraData = s.extraData || {};
          s.extraData[n] = sub.value;
          if (sub.type === 'image') {
            s.extraData[n + '.x'] = form.clk_x;
            s.extraData[n + '.y'] = form.clk_y;
          }
        }
      }
      var CLIENT_TIMEOUT_ABORT = 1;
      var SERVER_ABORT = 2;
      function getDoc(frame) {
        /* it looks like contentWindow or contentDocument do not
         * carry the protocol property in ie8, when running under ssl
         * frame.document is the only valid response document, since
         * the protocol is know but not on the other two objects. strange?
         * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
         */

        var doc = null;

        // IE8 cascading access check
        try {
          if (frame.contentWindow) {
            doc = frame.contentWindow.document;
          }
        } catch (err) {
          // IE8 access denied under ssl & missing protocol
          log('cannot get iframe.contentWindow document: ' + err);
        }
        if (doc) {
          // successful getting content
          return doc;
        }
        try {
          // simply checking may throw in ie8 under ssl or mismatched protocol
          doc = frame.contentDocument ? frame.contentDocument : frame.document;
        } catch (err) {
          // last attempt
          log('cannot get iframe.contentDocument: ' + err);
          doc = frame.document;
        }
        return doc;
      }

      // Rails CSRF hack (thanks to Yvan Barthelemy)
      var csrf_token = $('meta[name=csrf-token]').attr('content');
      var csrf_param = $('meta[name=csrf-param]').attr('content');
      if (csrf_param && csrf_token) {
        s.extraData = s.extraData || {};
        s.extraData[csrf_param] = csrf_token;
      }

      // take a breath so that pending repaints get some cpu time before the upload starts
      function doSubmit() {
        // make sure form attrs are set
        var t = $form.attr2('target'),
          a = $form.attr2('action'),
          mp = 'multipart/form-data',
          et = $form.attr('enctype') || $form.attr('encoding') || mp;

        // update form attrs in IE friendly way
        form.setAttribute('target', id);
        if (!method || /post/i.test(method)) {
          form.setAttribute('method', 'POST');
        }
        if (a !== s.url) {
          form.setAttribute('action', s.url);
        }

        // ie borks in some cases when setting encoding
        if (!s.skipEncodingOverride && (!method || /post/i.test(method))) {
          $form.attr({
            encoding: 'multipart/form-data',
            enctype: 'multipart/form-data'
          });
        }

        // support timout
        if (s.timeout) {
          timeoutHandle = setTimeout(function () {
            timedOut = true;
            cb(CLIENT_TIMEOUT_ABORT);
          }, s.timeout);
        }

        // look for server aborts
        function checkState() {
          try {
            var state = getDoc(io).readyState;
            log('state = ' + state);
            if (state && state.toLowerCase() === 'uninitialized') {
              setTimeout(checkState, 50);
            }
          } catch (e) {
            log('Server abort: ', e, ' (', e.name, ')');
            cb(SERVER_ABORT); // eslint-disable-line callback-return
            if (timeoutHandle) {
              clearTimeout(timeoutHandle);
            }
            timeoutHandle = undefined;
          }
        }

        // add "extra" data to form if provided in options
        var extraInputs = [];
        try {
          if (s.extraData) {
            for (var n in s.extraData) {
              if (s.extraData.hasOwnProperty(n)) {
                // if using the $.param format that allows for multiple values with the same name
                if ($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
                  extraInputs.push($('<input type="hidden" name="' + s.extraData[n].name + '">', ownerDocument).val(s.extraData[n].value).appendTo(form)[0]);
                } else {
                  extraInputs.push($('<input type="hidden" name="' + n + '">', ownerDocument).val(s.extraData[n]).appendTo(form)[0]);
                }
              }
            }
          }
          if (!s.iframeTarget) {
            // add iframe to doc and submit the form
            $io.appendTo($body);
          }
          if (io.attachEvent) {
            io.attachEvent('onload', cb);
          } else {
            io.addEventListener('load', cb, false);
          }
          setTimeout(checkState, 15);
          try {
            form.submit();
          } catch (err) {
            // just in case form has element with name/id of 'submit'
            var submitFn = document.createElement('form').submit;
            submitFn.apply(form);
          }
        } finally {
          // reset attrs and remove "extra" input elements
          form.setAttribute('action', a);
          form.setAttribute('enctype', et); // #380
          if (t) {
            form.setAttribute('target', t);
          } else {
            $form.removeAttr('target');
          }
          $(extraInputs).remove();
        }
      }
      if (s.forceSync) {
        doSubmit();
      } else {
        setTimeout(doSubmit, 10); // this lets dom updates render
      }
      var data,
        doc,
        domCheckCount = 50,
        callbackProcessed;
      function cb(e) {
        if (xhr.aborted || callbackProcessed) {
          return;
        }
        doc = getDoc(io);
        if (!doc) {
          log('cannot access response document');
          e = SERVER_ABORT;
        }
        if (e === CLIENT_TIMEOUT_ABORT && xhr) {
          xhr.abort('timeout');
          deferred.reject(xhr, 'timeout');
          return;
        }
        if (e === SERVER_ABORT && xhr) {
          xhr.abort('server abort');
          deferred.reject(xhr, 'error', 'server abort');
          return;
        }
        if (!doc || doc.location.href === s.iframeSrc) {
          // response not received yet
          if (!timedOut) {
            return;
          }
        }
        if (io.detachEvent) {
          io.detachEvent('onload', cb);
        } else {
          io.removeEventListener('load', cb, false);
        }
        var status = 'success',
          errMsg;
        try {
          if (timedOut) {
            throw 'timeout';
          }
          var isXml = s.dataType === 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
          log('isXml=' + isXml);
          if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
            if (--domCheckCount) {
              // in some browsers (Opera) the iframe DOM is not always traversable when
              // the onload callback fires, so we loop a bit to accommodate
              log('requeing onLoad callback, DOM not available');
              setTimeout(cb, 250);
              return;
            }
            // let this fall through because server response could be an empty document
            // log('Could not access iframe DOM after mutiple tries.');
            // throw 'DOMException: not available';
          }

          // log('response detected');
          var docRoot = doc.body ? doc.body : doc.documentElement;
          xhr.responseText = docRoot ? docRoot.innerHTML : null;
          xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
          if (isXml) {
            s.dataType = 'xml';
          }
          xhr.getResponseHeader = function (header) {
            var headers = {
              'content-type': s.dataType
            };
            return headers[header.toLowerCase()];
          };
          // support for XHR 'status' & 'statusText' emulation :
          if (docRoot) {
            xhr.status = Number(docRoot.getAttribute('status')) || xhr.status;
            xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
          }
          var dt = (s.dataType || '').toLowerCase();
          var scr = /(json|script|text)/.test(dt);
          if (scr || s.textarea) {
            // see if user embedded response in textarea
            var ta = doc.getElementsByTagName('textarea')[0];
            if (ta) {
              xhr.responseText = ta.value;
              // support for XHR 'status' & 'statusText' emulation :
              xhr.status = Number(ta.getAttribute('status')) || xhr.status;
              xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
            } else if (scr) {
              // account for browsers injecting pre around json response
              var pre = doc.getElementsByTagName('pre')[0];
              var b = doc.getElementsByTagName('body')[0];
              if (pre) {
                xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
              } else if (b) {
                xhr.responseText = b.textContent ? b.textContent : b.innerText;
              }
            }
          } else if (dt === 'xml' && !xhr.responseXML && xhr.responseText) {
            xhr.responseXML = toXml(xhr.responseText); // eslint-disable-line no-use-before-define
          }
          try {
            data = httpData(xhr, dt, s); // eslint-disable-line no-use-before-define
          } catch (err) {
            status = 'parsererror';
            xhr.error = errMsg = err || status;
          }
        } catch (err) {
          log('error caught: ', err);
          status = 'error';
          xhr.error = errMsg = err || status;
        }
        if (xhr.aborted) {
          log('upload aborted');
          status = null;
        }
        if (xhr.status) {
          // we've set xhr.status
          status = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304 ? 'success' : 'error';
        }

        // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
        if (status === 'success') {
          if (s.success) {
            s.success.call(s.context, data, 'success', xhr);
          }
          deferred.resolve(xhr.responseText, 'success', xhr);
          if (g) {
            $.event.trigger('ajaxSuccess', [xhr, s]);
          }
        } else if (status) {
          if (typeof errMsg === 'undefined') {
            errMsg = xhr.statusText;
          }
          if (s.error) {
            s.error.call(s.context, xhr, status, errMsg);
          }
          deferred.reject(xhr, 'error', errMsg);
          if (g) {
            $.event.trigger('ajaxError', [xhr, s, errMsg]);
          }
        }
        if (g) {
          $.event.trigger('ajaxComplete', [xhr, s]);
        }
        if (g && ! --$.active) {
          $.event.trigger('ajaxStop');
        }
        if (s.complete) {
          s.complete.call(s.context, xhr, status);
        }
        callbackProcessed = true;
        if (s.timeout) {
          clearTimeout(timeoutHandle);
        }

        // clean up
        setTimeout(function () {
          if (!s.iframeTarget) {
            $io.remove();
          } else {
            // adding else to clean up existing iframe response.
            $io.attr('src', s.iframeSrc);
          }
          xhr.responseXML = null;
        }, 100);
      }
      var toXml = $.parseXML || function (s, doc) {
        // use parseXML if available (jQuery 1.5+)
        if (window.ActiveXObject) {
          doc = new ActiveXObject('Microsoft.XMLDOM');
          doc.async = 'false';
          doc.loadXML(s);
        } else {
          doc = new DOMParser().parseFromString(s, 'text/xml');
        }
        return doc && doc.documentElement && doc.documentElement.nodeName !== 'parsererror' ? doc : null;
      };
      var parseJSON = $.parseJSON || function (s) {
        /* jslint evil:true */
        return window['eval']('(' + s + ')'); // eslint-disable-line dot-notation
      };
      var httpData = function httpData(xhr, type, s) {
        // mostly lifted from jq1.4.4

        var ct = xhr.getResponseHeader('content-type') || '',
          xml = (type === 'xml' || !type) && ct.indexOf('xml') >= 0,
          data = xml ? xhr.responseXML : xhr.responseText;
        if (xml && data.documentElement.nodeName === 'parsererror') {
          if ($.error) {
            $.error('parsererror');
          }
        }
        if (s && s.dataFilter) {
          data = s.dataFilter(data, type);
        }
        if (typeof data === 'string') {
          if ((type === 'json' || !type) && ct.indexOf('json') >= 0) {
            data = parseJSON(data);
          } else if ((type === 'script' || !type) && ct.indexOf('javascript') >= 0) {
            $.globalEval(data);
          }
        }
        return data;
      };
      return deferred;
    }
  };

  /**
   * ajaxForm() provides a mechanism for fully automating form submission.
   *
   * The advantages of using this method instead of ajaxSubmit() are:
   *
   * 1: This method will include coordinates for <input type="image"> elements (if the element
   *	is used to submit the form).
   * 2. This method will include the submit element's name/value data (for the element that was
   *	used to submit the form).
   * 3. This method binds the submit() method to the form for you.
   *
   * The options argument for ajaxForm works exactly as it does for ajaxSubmit. ajaxForm merely
   * passes the options argument along after properly binding events for submit elements and
   * the form itself.
   */
  $.fn.ajaxForm = function (options, data, dataType, onSuccess) {
    if (typeof options === 'string' || options === false && arguments.length > 0) {
      options = {
        'url': options,
        'data': data,
        'dataType': dataType
      };
      if (typeof onSuccess === 'function') {
        options.success = onSuccess;
      }
    }
    options = options || {};
    options.delegation = options.delegation && $.isFunction($.fn.on);

    // in jQuery 1.3+ we can fix mistakes with the ready state
    if (!options.delegation && this.length === 0) {
      var o = {
        s: this.selector,
        c: this.context
      };
      if (!$.isReady && o.s) {
        log('DOM not ready, queuing ajaxForm');
        $(function () {
          $(o.s, o.c).ajaxForm(options);
        });
        return this;
      }

      // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
      log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
      return this;
    }
    if (options.delegation) {
      $(document).off('submit.form-plugin', this.selector, doAjaxSubmit).off('click.form-plugin', this.selector, captureSubmittingElement).on('submit.form-plugin', this.selector, options, doAjaxSubmit).on('click.form-plugin', this.selector, options, captureSubmittingElement);
      return this;
    }
    if (options.beforeFormUnbind) {
      options.beforeFormUnbind(this, options);
    }
    return this.ajaxFormUnbind().on('submit.form-plugin', options, doAjaxSubmit).on('click.form-plugin', options, captureSubmittingElement);
  };

  // private event handlers
  function doAjaxSubmit(e) {
    /* jshint validthis:true */
    var options = e.data;
    if (!e.isDefaultPrevented()) {
      // if event has been canceled, don't proceed
      e.preventDefault();
      $(e.target).closest('form').ajaxSubmit(options); // #365
    }
  }
  function captureSubmittingElement(e) {
    /* jshint validthis:true */
    var target = e.target;
    var $el = $(target);
    if (!$el.is('[type=submit],[type=image]')) {
      // is this a child element of the submit el?  (ex: a span within a button)
      var t = $el.closest('[type=submit]');
      if (t.length === 0) {
        return;
      }
      target = t[0];
    }
    var form = target.form;
    form.clk = target;
    if (target.type === 'image') {
      if (typeof e.offsetX !== 'undefined') {
        form.clk_x = e.offsetX;
        form.clk_y = e.offsetY;
      } else if (typeof $.fn.offset === 'function') {
        var offset = $el.offset();
        form.clk_x = e.pageX - offset.left;
        form.clk_y = e.pageY - offset.top;
      } else {
        form.clk_x = e.pageX - target.offsetLeft;
        form.clk_y = e.pageY - target.offsetTop;
      }
    }
    // clear form vars
    setTimeout(function () {
      form.clk = form.clk_x = form.clk_y = null;
    }, 100);
  }

  // ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
  $.fn.ajaxFormUnbind = function () {
    return this.off('submit.form-plugin click.form-plugin');
  };

  /**
   * formToArray() gathers form element data into an array of objects that can
   * be passed to any of the following ajax functions: $.get, $.post, or load.
   * Each object in the array has both a 'name' and 'value' property. An example of
   * an array for a simple login form might be:
   *
   * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
   *
   * It is this array that is passed to pre-submit callback functions provided to the
   * ajaxSubmit() and ajaxForm() methods.
   */
  $.fn.formToArray = function (semantic, elements, filtering) {
    var a = [];
    if (this.length === 0) {
      return a;
    }
    var form = this[0];
    var formId = this.attr('id');
    var els = semantic || typeof form.elements === 'undefined' ? form.getElementsByTagName('*') : form.elements;
    var els2;
    if (els) {
      els = $.makeArray(els); // convert to standard array
    }

    // #386; account for inputs outside the form which use the 'form' attribute
    // FinesseRus: in non-IE browsers outside fields are already included in form.elements.
    if (formId && (semantic || /(Edge|Trident)\//.test(navigator.userAgent))) {
      els2 = $(':input[form="' + formId + '"]').get(); // hat tip @thet
      if (els2.length) {
        els = (els || []).concat(els2);
      }
    }
    if (!els || !els.length) {
      return a;
    }
    if ($.isFunction(filtering)) {
      els = $.map(els, filtering);
    }
    var i, j, n, v, el, max, jmax;
    for (i = 0, max = els.length; i < max; i++) {
      el = els[i];
      n = el.name;
      if (!n || el.disabled) {
        continue;
      }
      if (semantic && form.clk && el.type === 'image') {
        // handle image inputs on the fly when semantic == true
        if (form.clk === el) {
          a.push({
            name: n,
            value: $(el).val(),
            type: el.type
          });
          a.push({
            name: n + '.x',
            value: form.clk_x
          }, {
            name: n + '.y',
            value: form.clk_y
          });
        }
        continue;
      }
      v = $.fieldValue(el, true);
      if (v && v.constructor === Array) {
        if (elements) {
          elements.push(el);
        }
        for (j = 0, jmax = v.length; j < jmax; j++) {
          a.push({
            name: n,
            value: v[j]
          });
        }
      } else if (feature.fileapi && el.type === 'file') {
        if (elements) {
          elements.push(el);
        }
        var files = el.files;
        if (files.length) {
          for (j = 0; j < files.length; j++) {
            a.push({
              name: n,
              value: files[j],
              type: el.type
            });
          }
        } else {
          // #180
          a.push({
            name: n,
            value: '',
            type: el.type
          });
        }
      } else if (v !== null && typeof v !== 'undefined') {
        if (elements) {
          elements.push(el);
        }
        a.push({
          name: n,
          value: v,
          type: el.type,
          required: el.required
        });
      }
    }
    if (!semantic && form.clk) {
      // input type=='image' are not found in elements array! handle it here
      var $input = $(form.clk),
        input = $input[0];
      n = input.name;
      if (n && !input.disabled && input.type === 'image') {
        a.push({
          name: n,
          value: $input.val()
        });
        a.push({
          name: n + '.x',
          value: form.clk_x
        }, {
          name: n + '.y',
          value: form.clk_y
        });
      }
    }
    return a;
  };

  /**
   * Serializes form data into a 'submittable' string. This method will return a string
   * in the format: name1=value1&amp;name2=value2
   */
  $.fn.formSerialize = function (semantic) {
    // hand off to jQuery.param for proper encoding
    return $.param(this.formToArray(semantic));
  };

  /**
   * Serializes all field elements in the jQuery object into a query string.
   * This method will return a string in the format: name1=value1&amp;name2=value2
   */
  $.fn.fieldSerialize = function (successful) {
    var a = [];
    this.each(function () {
      var n = this.name;
      if (!n) {
        return;
      }
      var v = $.fieldValue(this, successful);
      if (v && v.constructor === Array) {
        for (var i = 0, max = v.length; i < max; i++) {
          a.push({
            name: n,
            value: v[i]
          });
        }
      } else if (v !== null && typeof v !== 'undefined') {
        a.push({
          name: this.name,
          value: v
        });
      }
    });

    // hand off to jQuery.param for proper encoding
    return $.param(a);
  };

  /**
   * Returns the value(s) of the element in the matched set. For example, consider the following form:
   *
   *	<form><fieldset>
   *		<input name="A" type="text">
   *		<input name="A" type="text">
   *		<input name="B" type="checkbox" value="B1">
   *		<input name="B" type="checkbox" value="B2">
   *		<input name="C" type="radio" value="C1">
   *		<input name="C" type="radio" value="C2">
   *	</fieldset></form>
   *
   *	var v = $('input[type=text]').fieldValue();
   *	// if no values are entered into the text inputs
   *	v === ['','']
   *	// if values entered into the text inputs are 'foo' and 'bar'
   *	v === ['foo','bar']
   *
   *	var v = $('input[type=checkbox]').fieldValue();
   *	// if neither checkbox is checked
   *	v === undefined
   *	// if both checkboxes are checked
   *	v === ['B1', 'B2']
   *
   *	var v = $('input[type=radio]').fieldValue();
   *	// if neither radio is checked
   *	v === undefined
   *	// if first radio is checked
   *	v === ['C1']
   *
   * The successful argument controls whether or not the field element must be 'successful'
   * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
   * The default value of the successful argument is true. If this value is false the value(s)
   * for each element is returned.
   *
   * Note: This method *always* returns an array. If no valid value can be determined the
   *	array will be empty, otherwise it will contain one or more values.
   */
  $.fn.fieldValue = function (successful) {
    for (var val = [], i = 0, max = this.length; i < max; i++) {
      var el = this[i];
      var v = $.fieldValue(el, successful);
      if (v === null || typeof v === 'undefined' || v.constructor === Array && !v.length) {
        continue;
      }
      if (v.constructor === Array) {
        $.merge(val, v);
      } else {
        val.push(v);
      }
    }
    return val;
  };

  /**
   * Returns the value of the field element.
   */
  $.fieldValue = function (el, successful) {
    var n = el.name,
      t = el.type,
      tag = el.tagName.toLowerCase();
    if (typeof successful === 'undefined') {
      successful = true;
    }

    /* eslint-disable no-mixed-operators */
    if (successful && (!n || el.disabled || t === 'reset' || t === 'button' || (t === 'checkbox' || t === 'radio') && !el.checked || (t === 'submit' || t === 'image') && el.form && el.form.clk !== el || tag === 'select' && el.selectedIndex === -1)) {
      /* eslint-enable no-mixed-operators */
      return null;
    }
    if (tag === 'select') {
      var index = el.selectedIndex;
      if (index < 0) {
        return null;
      }
      var a = [],
        ops = el.options;
      var one = t === 'select-one';
      var max = one ? index + 1 : ops.length;
      for (var i = one ? index : 0; i < max; i++) {
        var op = ops[i];
        if (op.selected && !op.disabled) {
          var v = op.value;
          if (!v) {
            // extra pain for IE...
            v = op.attributes && op.attributes.value && !op.attributes.value.specified ? op.text : op.value;
          }
          if (one) {
            return v;
          }
          a.push(v);
        }
      }
      return a;
    }
    return $(el).val().replace(rCRLF, '\r\n');
  };

  /**
   * Clears the form data. Takes the following actions on the form's input fields:
   *  - input text fields will have their 'value' property set to the empty string
   *  - select elements will have their 'selectedIndex' property set to -1
   *  - checkbox and radio inputs will have their 'checked' property set to false
   *  - inputs of type submit, button, reset, and hidden will *not* be effected
   *  - button elements will *not* be effected
   */
  $.fn.clearForm = function (includeHidden) {
    return this.each(function () {
      $('input,select,textarea', this).clearFields(includeHidden);
    });
  };

  /**
   * Clears the selected form elements.
   */
  $.fn.clearFields = $.fn.clearInputs = function (includeHidden) {
    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list

    return this.each(function () {
      var t = this.type,
        tag = this.tagName.toLowerCase();
      if (re.test(t) || tag === 'textarea') {
        this.value = '';
      } else if (t === 'checkbox' || t === 'radio') {
        this.checked = false;
      } else if (tag === 'select') {
        this.selectedIndex = -1;
      } else if (t === 'file') {
        if (/MSIE/.test(navigator.userAgent)) {
          $(this).replaceWith($(this).clone(true));
        } else {
          $(this).val('');
        }
      } else if (includeHidden) {
        // includeHidden can be the value true, or it can be a selector string
        // indicating a special test; for example:
        // $('#myForm').clearForm('.special:hidden')
        // the above would clean hidden inputs that have the class of 'special'
        if (includeHidden === true && /hidden/.test(t) || typeof includeHidden === 'string' && $(this).is(includeHidden)) {
          this.value = '';
        }
      }
    });
  };

  /**
   * Resets the form data or individual elements. Takes the following actions
   * on the selected tags:
   * - all fields within form elements will be reset to their original value
   * - input / textarea / select fields will be reset to their original value
   * - option / optgroup fields (for multi-selects) will defaulted individually
   * - non-multiple options will find the right select to default
   * - label elements will be searched against its 'for' attribute
   * - all others will be searched for appropriate children to default
   */
  $.fn.resetForm = function () {
    return this.each(function () {
      var el = $(this);
      var tag = this.tagName.toLowerCase();
      switch (tag) {
        case 'input':
          this.checked = this.defaultChecked;
        // fall through

        case 'textarea':
          this.value = this.defaultValue;
          return true;
        case 'option':
        case 'optgroup':
          var select = el.parents('select');
          if (select.length && select[0].multiple) {
            if (tag === 'option') {
              this.selected = this.defaultSelected;
            } else {
              el.find('option').resetForm();
            }
          } else {
            select.resetForm();
          }
          return true;
        case 'select':
          el.find('option').each(function (i) {
            // eslint-disable-line consistent-return
            this.selected = this.defaultSelected;
            if (this.defaultSelected && !el[0].multiple) {
              el[0].selectedIndex = i;
              return false;
            }
          });
          return true;
        case 'label':
          var forEl = $(el.attr('for'));
          var list = el.find('input,select,textarea');
          if (forEl[0]) {
            list.unshift(forEl[0]);
          }
          list.resetForm();
          return true;
        case 'form':
          // guard against an input with the name of 'reset'
          // note that IE reports the reset function as an 'object'
          if (typeof this.reset === 'function' || _typeof(this.reset) === 'object' && !this.reset.nodeType) {
            this.reset();
          }
          return true;
        default:
          el.find('form,input,label,select,textarea').resetForm();
          return true;
      }
    });
  };

  /**
   * Enables or disables any matching elements.
   */
  $.fn.enable = function (b) {
    if (typeof b === 'undefined') {
      b = true;
    }
    return this.each(function () {
      this.disabled = !b;
    });
  };

  /**
   * Checks/unchecks any matching checkboxes or radio buttons and
   * selects/deselects and matching option elements.
   */
  $.fn.selected = function (select) {
    if (typeof select === 'undefined') {
      select = true;
    }
    return this.each(function () {
      var t = this.type;
      if (t === 'checkbox' || t === 'radio') {
        this.checked = select;
      } else if (this.tagName.toLowerCase() === 'option') {
        var $sel = $(this).parent('select');
        if (select && $sel[0] && $sel[0].type === 'select-one') {
          // deselect all other options
          $sel.find('option').selected(false);
        }
        this.selected = select;
      }
    });
  };

  // expose debug var
  $.fn.ajaxSubmit.debug = false;

  // helper fn for console logging
  function log() {
    if (!$.fn.ajaxSubmit.debug) {
      return;
    }
    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments, '');
    if (window.console && window.console.log) {
      window.console.log(msg);
    } else if (window.opera && window.opera.postError) {
      window.opera.postError(msg);
    }
  }
});
jQuery(function ($) {
  // HAMBURGER MENU
  // --------------
  $('.m-hamburger').click(function () {
    $(this).toggleClass('is-open');
  });

  // ADD DATA-VALIDATION ATTRIBUTES TO CF7 INPUT
  // -------------------------------------------
  $('.wpcf7-validates-as-required[type=text]').attr('data-validation', 'required');
  $('.wpcf7-validates-as-required[type=email]').attr('data-validation', 'email');
  $('.wpcf7-validates-as-required[type=url]').attr('data-validation', 'url');
  $('.wpcf7-validates-as-required[type=tel]').attr('data-validation', 'number');
  $('.wpcf7-validates-as-required[type=number]').attr('data-validation', 'number');
  $('.wpcf7-validates-as-required[type=date]').attr('data-validation', 'date');
  $('textarea.wpcf7-validates-as-required').attr('data-validation', 'required');
  $('select.wpcf7-validates-as-required').attr('data-validation', 'required');
  $('.wpcf7-validates-as-required input[type=checkbox]').attr('data-validation', 'required');
  $('.wpcf7-validates-as-required[type=checkbox]').attr('data-validation', 'required');
  $('.wpcf7-validates-as-required[type=file]').attr('data-validation', 'required');

  // INIT JQUERY FORM VALIDATOR
  // --------------------------
  var ita = {
    errorTitle: 'Invio della richiesta fallito!',
    requiredFields: 'Questo campo è obbligatorio',
    badTime: 'Non hai inserito un orario corretto',
    badEmail: 'L\'indirizzo email non è corretto',
    badTelephone: 'Non hai inserito un numero di telefono corretto',
    badSecurityAnswer: 'Non hai dato una risposta esatta alla domanda di sicurezza',
    badDate: 'Non hai inserito una data corretta',
    lengthBadStart: 'Devi inserire una risposta tra ',
    lengthBadEnd: ' caratteri',
    lengthTooLongStart: 'Non hai dato una risposta più lunga di ',
    lengthTooShortStart: 'Non hai dato una risposta più corta di ',
    notConfirmed: 'I valori non possono essere confermati',
    badDomain: 'Valore di dominio non corretto',
    badUrl: 'La tua risposta non è un URL corretto',
    badCustomVal: 'Hai dato una risposta non corretts',
    badInt: 'La risposta che hai dato non è un numero corretto',
    badSecurityNumber: 'Il tuo numero di sicurezza non è corretto',
    badUKVatAnswer: 'Numero UK VAT non corretto',
    badStrength: 'La password non è abbastanza sicura',
    badNumberOfSelectedOptionsStart: 'Devi scegliere almeno ',
    badNumberOfSelectedOptionsEnd: ' risposte',
    badAlphaNumeric: 'La risposta deve contenere solo caratteri alfanumerici ',
    badAlphaNumericExtra: ' e ',
    wrongFileSize: 'Il file che vuoi caricare è troppo grande',
    wrongFileType: 'Il file che vuoi caricare non è del tipo corretto',
    groupCheckedRangeStart: 'Scegli tra ',
    groupCheckedTooFewStart: 'Scegli almeno ',
    groupCheckedTooManyStart: 'Scegli un massimo di ',
    groupCheckedEnd: ' campo/i'
  };
  $.validate({
    form: ".wpcf7-form",
    language: ita,
    borderColorOnError: '',
    onSuccess: function onSuccess(form) {
      // Tracking con Google Tag Manager
      // Nota: solo nella form Contatti della pagina Contatta il progettista
      var formId = $(form[0]).parents(".wpcf7").attr("id");
      if (formId == "wpcf7-f25440-p25416-o1") {
        var prjName = $("h1.heading").text();
        if ((typeof dataLayer === "undefined" ? "undefined" : _typeof(dataLayer)) === "object") {
          dataLayer.push({
            'event': 'form-contatta-progettista',
            'progettista': prjName
          });
        } else {
          console.log("dataLayer.push({ 'event': 'form-contatta-progettista', 'progettista': " + prjName + " });");
        }
      }
      var thankyouURL = $(form[0]).parents('.wpcf7').next().text();
      location.assign(thankyouURL);
    }
  });

  // INIT AJAXFORM ON CF7 FORMS
  // --------------------------
  $('.wpcf7-form').ajaxForm();
});
var progress = document.querySelectorAll(".c-progress");
[].forEach.call(progress, function (el) {
  el.classList.add("start");
  setTimeout(function () {
    el.classList.remove("start");
    el.classList.add("anim");
  }, 10);
});
var overlayBtn = document.querySelectorAll('.c-btn--overlay');
if (overlayBtn.length > 0) {
  for (i = 0; i < overlayBtn.length; i++) {
    overlayBtn[i].addEventListener('click', function () {
      this.parentNode.classList.add("c-overlay--is-hidden");
    });
  }
}

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;
(function (factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};
  Slick = function () {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
        dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(slider, i) {
          return $('<button type="button" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }();
  Slick.prototype.activateADA = function () {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;
    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }
    _.unload();
    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
      _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function step(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function complete() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function () {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function () {
    var _ = this,
      asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function (index) {
    var _ = this,
      asNavFor = _.getNavTarget();
    if (asNavFor !== null && _typeof(asNavFor) === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
      transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function () {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function () {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function () {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function () {
    var _ = this,
      i,
      dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul />').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function () {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function () {
    var _ = this,
      a,
      b,
      c,
      newSlides,
      numOfSlides,
      originalSlides,
      slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('div');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
      breakpoint,
      targetBreakpoint,
      respondToWidth,
      triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      // only trigger breakpoints during an actual break. not on initialize.
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
      $target = $(event.currentTarget),
      indexOffset,
      slideOffset,
      unevenOffset;

    // If target is a link, prevent default action.
    if ($target.is('a')) {
      event.preventDefault();
    }

    // If target is not the <li> element (ie: a child), find the <li>.
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
      navigables,
      prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function () {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function () {
    var _ = this,
      originalSlides;
    if (_.options.rows > 0) {
      originalSlides = _.$slides.children().children();
      originalSlides.removeAttr('style');
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function (event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function (refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
      transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });
      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function () {
    var _ = this;
    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');
          _.autoPlay();
        }
      }, 0);
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function () {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide,
      coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = verticalHeight * _.options.slidesToShow * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function () {
    return this;
  };
  Slick.prototype.getSlideCount = function () {
    var _ = this,
      slidesTraversed,
      swipedSlide,
      centerOffset;
    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };
  Slick.prototype.init = function (creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function () {
    var _ = this,
      numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
      tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
        return val >= 0 && val < _.slideCount;
      });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'tabpanel',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({
              'aria-describedby': ariaButtonControl
            });
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({
          'role': 'presentation'
        });
        $(this).find('button').first().attr({
          'role': 'tab',
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': i + 1 + ' of ' + numDotGroups,
          'aria-selected': null,
          'tabindex': '-1'
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        _.$slides.eq(i).attr({
          'tabindex': '0'
        });
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function () {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$dots.on('keydown.slick', _.keyHandler);
      }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function () {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function () {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function (event) {
    var _ = this;
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };
  Slick.prototype.lazyLoad = function () {
    var _ = this,
      loadRange,
      cloneRange,
      rangeStart,
      rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageSrcSet = $(this).attr('data-srcset'),
          imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
          imageToLoad = document.createElement('img');
        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function () {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({
      opacity: 1
    });
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };
  Slick.prototype.orientationChange = function () {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function (index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', 0).focus();
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };
  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageSrcSet,
      imageSizes,
      imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function () {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function (initializing) {
    var _ = this,
      currentSlide,
      lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    // in non-infinite sliders, we don't want to go past the
    // last visible index.
    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    }

    // if less slides than to show, go to start.
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });
    _.init();
    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };
  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
      breakpoint,
      currentBreakpoint,
      l,
      responsiveSettings = _.options.responsive || null;
    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function () {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function () {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;
    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function (position) {
    var _ = this,
      positionProps = {},
      x,
      y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function () {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function () {
    var _ = this,
      targetLeft;
    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };
  Slick.prototype.setHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
    /**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */

    var _ = this,
      l,
      item,
      option,
      value,
      refresh = false,
      type;
    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;

          // loop through the responsive object and splice out duplicates.
          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function () {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function () {
    var _ = this,
      bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };
  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
      centerOffset,
      allSlides,
      indexOffset,
      remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function () {
    var _ = this,
      i,
      slideIndex,
      infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });
      }
    }
  };
  Slick.prototype.interrupt = function (toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function (event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
      animSlide,
      oldSlide,
      slideLeft,
      targetLeft = null,
      _ = this,
      navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function () {
    var xDist,
      yDist,
      r,
      swipeAngle,
      _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }
    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
      slideCount,
      direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function (event) {
    var _ = this;
    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function (event) {
    var _ = this,
      edgeWasHit = false,
      curLeft,
      swipeDirection,
      swipeLength,
      positionOffset,
      touches,
      verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function (event) {
    var _ = this,
      touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function () {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function () {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function () {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (_typeof(opt) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };
});
"use strict";
!function (t) {
  var i, n;
  i = function () {
    function i(i, n) {
      var o;
      this.options = n, this.$element = t(i), this.didInit = !1, o = this, this.$element.on("click.slickLightbox", this.options.itemSelector, function (i) {
        var n, s;
        if (i.preventDefault(), n = t(this), "function" != typeof o.options.shouldOpen || o.options.shouldOpen(o, n)) return s = o.filterOutSlickClones(o.$element.find(o.options.itemSelector)), o.init(s.index(n));
      });
    }
    return i.prototype.init = function (t) {
      return this.didInit = !0, this.detectIE(), this.createModal(), this.bindEvents(), this.initSlick(t), this.open();
    }, i.prototype.createModalItems = function () {
      var i, n, o;
      return this.options.images ? o = t.map(this.options.images, function (t) {
        return '<div class="slick-lightbox-slick-item"><div class="slick-lightbox-slick-item-inner"><img class="slick-lightbox-slick-img" src="' + t + '" /></div></div>';
      }) : (n = function (t) {
        return function (i) {
          var n, o;
          return n = t.getElementCaption(i), o = t.getElementSrc(i), '<div class="slick-lightbox-slick-item"><div class="slick-lightbox-slick-item-inner"><img class="slick-lightbox-slick-img" src="' + o + '" />' + n + "</div></div>";
        };
      }(this), i = this.filterOutSlickClones(this.$element.find(this.options.itemSelector)), o = t.map(i, n)), o;
    }, i.prototype.createModal = function () {
      var i, n;
      return n = this.createModalItems(), i = '<div class="slick-lightbox slick-lightbox-hide-init' + (this.isIE ? " slick-lightbox-ie" : "") + '" style="background: ' + this.options.background + ';">\n  <div class="slick-lightbox-inner">\n    <div class="slick-lightbox-slick slick-caption-' + this.options.captionPosition + '">' + n.join("") + "</div>\n  <div>\n<div>", this.$modalElement = t(i), this.$parts = {}, this.$parts.closeButton = t(this.options.layouts.closeButton), this.$modalElement.find(".slick-lightbox-inner").append(this.$parts.closeButton), t("body").append(this.$modalElement);
    }, i.prototype.initSlick = function (i) {
      var n;
      return n = {
        initialSlide: i
      }, null != this.options.slick ? "function" == typeof this.options.slick ? this.slick = this.options.slick(this.$modalElement) : this.slick = this.$modalElement.find(".slick-lightbox-slick").slick(t.extend({}, this.options.slick, n)) : this.slick = this.$modalElement.find(".slick-lightbox-slick").slick(n), this.$modalElement.trigger("init.slickLightbox");
    }, i.prototype.open = function () {
      return this.options.useHistoryApi && this.writeHistory(), this.$element.trigger("show.slickLightbox"), setTimeout(function (t) {
        return function () {
          return t.$element.trigger("shown.slickLightbox");
        };
      }(this), this.getTransitionDuration()), this.$modalElement.removeClass("slick-lightbox-hide-init");
    }, i.prototype.close = function () {
      return this.$element.trigger("hide.slickLightbox"), setTimeout(function (t) {
        return function () {
          return t.$element.trigger("hidden.slickLightbox");
        };
      }(this), this.getTransitionDuration()), this.$modalElement.addClass("slick-lightbox-hide"), this.destroy();
    }, i.prototype.bindEvents = function () {
      var i;
      if (i = function (t) {
        return function () {
          var i;
          return i = t.$modalElement.find(".slick-lightbox-inner").height(), t.$modalElement.find(".slick-lightbox-slick-item").height(i), t.$modalElement.find(".slick-lightbox-slick-img, .slick-lightbox-slick-item-inner").css("max-height", Math.round(t.options.imageMaxHeight * i));
        };
      }(this), t(window).on("orientationchange.slickLightbox resize.slickLightbox", i), this.options.useHistoryApi && t(window).on("popstate.slickLightbox", function (t) {
        return function () {
          return t.close();
        };
      }(this)), this.$modalElement.on("init.slickLightbox", i), this.$modalElement.on("destroy.slickLightbox", function (t) {
        return function () {
          return t.destroy();
        };
      }(this)), this.$element.on("destroy.slickLightbox", function (t) {
        return function () {
          return t.destroy(!0);
        };
      }(this)), this.$parts.closeButton.on("click.slickLightbox touchstart.slickLightbox", function (t) {
        return function (i) {
          return i.preventDefault(), t.close();
        };
      }(this)), (this.options.closeOnEscape || this.options.navigateByKeyboard) && t(document).on("keydown.slickLightbox", function (t) {
        return function (i) {
          var n;
          if (n = i.keyCode ? i.keyCode : i.which, t.options.navigateByKeyboard && (37 === n ? t.slideSlick("left") : 39 === n && t.slideSlick("right")), t.options.closeOnEscape && 27 === n) return t.close();
        };
      }(this)), this.options.closeOnBackdropClick) return this.$modalElement.on("click.slickLightbox touchstart.slickLightbox", ".slick-lightbox-slick-img", function (t) {
        return t.stopPropagation();
      }), this.$modalElement.on("click.slickLightbox", ".slick-lightbox-slick-item", function (t) {
        return function (i) {
          return i.preventDefault(), t.close();
        };
      }(this));
    }, i.prototype.slideSlick = function (t) {
      return "left" === t ? this.slick.slick("slickPrev") : this.slick.slick("slickNext");
    }, i.prototype.detectIE = function () {
      var t;
      if (this.isIE = !1, /MSIE (\d+\.\d+);/.test(navigator.userAgent) && (t = new Number(RegExp.$1), t < 9)) return this.isIE = !0;
    }, i.prototype.getElementCaption = function (i) {
      var n;
      return this.options.caption ? (n = function () {
        switch (_typeof(this.options.caption)) {
          case "function":
            return this.options.caption(i);
          case "string":
            return t(i).data(this.options.caption);
        }
      }.call(this), '<span class="slick-lightbox-slick-caption">' + n + "</span>") : "";
    }, i.prototype.getElementSrc = function (i) {
      switch (_typeof(this.options.src)) {
        case "function":
          return this.options.src(i);
        case "string":
          return t(i).attr(this.options.src);
        default:
          return i.href;
      }
    }, i.prototype.unbindEvents = function () {
      return t(window).off(".slickLightbox"), t(document).off(".slickLightbox"), this.$modalElement.off(".slickLightbox");
    }, i.prototype.destroy = function (t) {
      if (null == t && (t = !1), this.didInit && (this.unbindEvents(), setTimeout(function (t) {
        return function () {
          return t.$modalElement.remove();
        };
      }(this), this.options.destroyTimeout)), t) return this.$element.off(".slickLightbox"), this.$element.off(".slickLightbox", this.options.itemSelector);
    }, i.prototype.destroyPrevious = function () {
      return t("body").children(".slick-lightbox").trigger("destroy.slickLightbox");
    }, i.prototype.getTransitionDuration = function () {
      var t;
      return this.transitionDuration ? this.transitionDuration : (t = this.$modalElement.css("transition-duration"), "undefined" == typeof t ? this.transitionDuration = 500 : this.transitionDuration = t.indexOf("ms") > -1 ? parseFloat(t) : 1e3 * parseFloat(t));
    }, i.prototype.writeHistory = function () {
      return "undefined" != typeof history && null !== history && "function" == typeof history.pushState ? history.pushState(null, null, "") : void 0;
    }, i.prototype.filterOutSlickClones = function (i) {
      return this.$element.hasClass("slick-slider") ? i = i.filter(function () {
        var i;
        return i = t(this), !i.hasClass("slick-cloned") && 0 === i.parents(".slick-cloned").length;
      }) : i;
    }, i;
  }(), n = {
    background: "rgba(0,0,0,.8)",
    closeOnEscape: !0,
    closeOnBackdropClick: !0,
    destroyTimeout: 500,
    itemSelector: "a",
    navigateByKeyboard: !0,
    src: !1,
    caption: !1,
    captionPosition: "dynamic",
    images: !1,
    slick: {},
    useHistoryApi: !1,
    layouts: {
      closeButton: '<button type="button" class="slick-lightbox-close"></button>'
    },
    shouldOpen: null,
    imageMaxHeight: .9
  }, t.fn.slickLightbox = function (o) {
    return o = t.extend({}, n, o), t(this).each(function () {
      return this.slickLightbox = new i(this, o);
    }), this;
  }, t.fn.unslickLightbox = function () {
    return t(this).trigger("destroy.slickLightbox").each(function () {
      return this.slickLightbox = null;
    });
  };
}(jQuery);
(function ($) {
  //Attach this new method to jQuery
  $.fn.extend({
    //This is where you write your plugin's name
    champ: function champ(options) {
      //Iterate over the current set of matched elements

      var defaults = {
        selector: "tab_wrapper",
        plugin_type: "tab",
        side: "",
        active_tab: "1",
        controllers: "false",
        ajax: "false",
        show_ajax_content_in_tab: "false",
        content_path: "false"
      };
      var obj = $.extend(defaults, options);
      var li_rel = 1,
        div_rel = 1;
      return this.each(function () {
        var plugin_type = obj.plugin_type;
        var side = obj.side;
        var active_tab = obj.active_tab;
        var controllers = obj.controllers;
        var ajax = obj.ajax;
        var show_ajax_content_in_tab = obj.show_ajax_content_in_tab;
        var content_path = obj.content_path;
        var tab_content_selector = $(this).find(" > div > div.tab_content");
        var tab_selector = $(this).find(" >ul li");
        var parent = $(this);
        var controller_parent = $(".controller").closest(".tab_wrapper");
        var con_siblings;
        parent.addClass(side + "_side");
        if (controllers == "true") {
          parent.addClass("withControls");
          parent.append("<div class='controller'><span class='previous'>previous</span><span class='next'>next</span></div>");
        }
        if (plugin_type == "accordion") {
          //alert(34);
          parent.addClass("accordion");
          parent.removeClass(side + "_side");
          parent.removeClass("withControls");
          $(".controller", parent).remove();
        }
        if (ajax == "true") {
          $.ajax({
            url: content_path,
            success: function success(result) {
              $(" .tab_content.tab_" + show_ajax_content_in_tab, parent).html(result);
            }
          });
          $(document).ajaxError(function (event, request, settings) {
            $(" .tab_content.tab_" + show_ajax_content_in_tab, parent).prepend("<h4 class='error'>Error requesting page " + settings.url + "</h2>");
          });
        }
        function hide_controls(parent) {
          if (parent.find(" >ul li:eq(0)").hasClass("active")) {
            $(".controller .previous", parent).hide();
          } else {
            $(".controller .previous", parent).show();
          }
          if (parent.find(" >ul li").last().hasClass("active")) {
            $(".controller .next", parent).hide();
          } else {
            $(".controller .next", parent).show();
          }
        }
        $(".controller .previous", $(this)).click(function () {
          con_siblings = $(this).closest(".controller");
          con_siblings.siblings("ul").find("li.active").prev().trigger("click");
          hide_controls(controller_parent);
        });
        $(".controller .next", $(this)).click(function () {
          con_siblings = $(this).closest(".controller");
          con_siblings.siblings("ul").find("li.active").next().trigger("click");
          hide_controls(controller_parent);
        });
        $(this).find(" >ul li").removeClass("active");
        $(this).find(" > div > div.tab_content").removeClass("active");
        if (active_tab == "") {
          $(this).find(" >ul li:eq(0)").addClass("active").show(); //set active tab on load   
          $(this).find(" > div > div.tab_content:eq(0)").addClass("active").show(); //set active tab on load   
          hide_controls(parent);
        } else {
          $(this).find(" >ul li:eq(" + (active_tab - 1) + ")").addClass("active").show(); //set active tab on load
          $(this).find(" > div > div.tab_content:eq(" + (active_tab - 1) + ")").addClass("active").show(); //set active tab on load
          hide_controls(parent);
        }
        tab_content_selector.first().addClass("first");
        tab_content_selector.last().addClass("last");

        // add class to content div
        tab_content_selector.each(function () {
          var add_relation = "tab_" + div_rel;
          $(this).addClass(add_relation);
          $(this).attr("title", add_relation);
          div_rel++;
        });

        // add relation attr to li and generate accordion header for mobile
        tab_selector.each(function () {
          var accordian_header = $(this).text();
          var add_relation = "tab_" + li_rel;
          var get_parent = $(this).closest(".tab_wrapper");
          $(this).attr("rel", add_relation);
          var current_tab_class = $(this).attr("class");
          tab_content_selector.each(function () {
            if ($(this).hasClass(add_relation)) {
              get_parent.find(" > div > div.tab_content." + add_relation).before("<div title='" + add_relation + "' class='accordian_header " + add_relation + ' ' + current_tab_class + "'>" + accordian_header + "<span class='arrow'></span></div>");
            }
          });
          li_rel++;
        });

        // on click of accordion header slideUp/DlideDuwon respective content
        $(".accordian_header").click(function () {
          var clicked_header = $(this).attr("title");
          var content_status = $(this).next(".tab_content").css("display");
          var get_closest_parent = $(this).closest(".tab_wrapper");
          if (content_status == "none") {
            $(".accordian_header").removeClass("active");
            $(this).addClass("active");
            tab_content_selector.removeClass("active").slideUp();
            get_closest_parent.find(" > div > div.tab_content." + clicked_header).addClass("active").slideDown();
          }
        });

        // on click of tab hide/show respective content
        tab_selector.click(function () {
          var clicked_tab = $(this).attr("rel");
          var get_new_closest_parent = $(this).closest(".tab_wrapper");
          get_new_closest_parent.find(" .accordian_header").removeClass("active");
          get_new_closest_parent.find(" .accordian_header." + clicked_tab).addClass("active");
          tab_content_selector.removeClass("active").hide();
          get_new_closest_parent.find(" > div > div.tab_content." + clicked_tab).addClass("active").show();
          tab_selector.removeClass("active");
          $(this).addClass("active");
          hide_controls(get_new_closest_parent);
        });
      });
    }
  });
})(jQuery);
/*!
 * @copyright Copyright (c) 2016 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.1.23
 */
(function () {
  if (window && window.addEventListener) {
    var e = Object.create(null),
      l,
      r,
      d = function d() {
        clearTimeout(r);
        r = setTimeout(l, 100);
      },
      p = function p() {},
      t = function t() {
        var g;
        window.addEventListener("resize", d, !1);
        window.addEventListener("orientationchange", d, !1);
        window.MutationObserver ? (g = new MutationObserver(d), g.observe(document.documentElement, {
          childList: !0,
          subtree: !0,
          attributes: !0
        }), p = function p() {
          try {
            g.disconnect(), window.removeEventListener("resize", d, !1), window.removeEventListener("orientationchange", d, !1);
          } catch (m) {}
        }) : (document.documentElement.addEventListener("DOMSubtreeModified", d, !1), p = function p() {
          document.documentElement.removeEventListener("DOMSubtreeModified", d, !1);
          window.removeEventListener("resize", d, !1);
          window.removeEventListener("orientationchange", d, !1);
        });
      },
      u = function u(g) {
        function e(a) {
          var c;
          void 0 !== a.protocol ? c = a : (c = document.createElement("a"), c.href = a);
          return c.protocol.replace(/:/g, "") + c.host;
        }
        var d, n;
        window.XMLHttpRequest && (d = new XMLHttpRequest(), n = e(location), g = e(g), d = void 0 === d.withCredentials && "" !== g && g !== n ? XDomainRequest || void 0 : XMLHttpRequest);
        return d;
      };
    l = function l() {
      function d() {
        --q;
        0 === q && (p(), t());
      }
      function m(a) {
        return function () {
          !0 !== e[a.base] && a.useEl.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + a.hash);
        };
      }
      function l(a) {
        return function () {
          var c = document.body,
            b = document.createElement("x");
          a.onload = null;
          b.innerHTML = a.responseText;
          if (b = b.getElementsByTagName("svg")[0]) b.setAttribute("aria-hidden", "true"), b.style.position = "absolute", b.style.width = 0, b.style.height = 0, b.style.overflow = "hidden", c.insertBefore(b, c.firstChild);
          d();
        };
      }
      function n(a) {
        return function () {
          a.onerror = null;
          a.ontimeout = null;
          d();
        };
      }
      var a,
        c,
        f,
        h,
        q = 0,
        b,
        k;
      p();
      k = document.getElementsByTagName("use");
      for (h = 0; h < k.length; h += 1) {
        try {
          c = k[h].getBoundingClientRect();
        } catch (v) {
          c = !1;
        }
        f = (a = k[h].getAttributeNS("http://www.w3.org/1999/xlink", "href")) && a.split ? a.split("#") : ["", ""];
        a = f[0];
        f = f[1];
        b = c && 0 === c.left && 0 === c.right && 0 === c.top && 0 === c.bottom;
        c && 0 === c.width && 0 === c.height && !b ? a.length && (b = e[a], !0 !== b && setTimeout(m({
          useEl: k[h],
          base: a,
          hash: f
        }), 0), void 0 === b && (f = u(a), void 0 !== f && (b = new f(), e[a] = b, b.onload = l(b), b.onerror = n(b), b.ontimeout = n(b), b.open("GET", a), b.send(), q += 1))) : b ? a.length && e[a] && m({
          useEl: k[h],
          base: a,
          hash: f
        })() : void 0 === e[a] ? e[a] = !0 : e[a].onload && (e[a].abort(), delete e[a].onload, e[a] = !0);
      }
      k = "";
      q += 1;
      d();
    };
    window.addEventListener("load", function m() {
      window.removeEventListener("load", m, !1);
      r = setTimeout(l, 0);
    }, !1);
  }
})();

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-setclasses !*/
!function (e, n, t) {
  function r(e, n) {
    return _typeof(e) === n;
  }
  function o() {
    var e, n, t, o, i, s, a;
    for (var f in g) if (g.hasOwnProperty(f)) {
      if (e = [], n = g[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) e.push(n.options.aliases[t].toLowerCase());
      for (o = r(n.fn, "function") ? n.fn() : n.fn, i = 0; i < e.length; i++) s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), y.push((o ? "" : "no-") + a.join("-"));
    }
  }
  function i(e) {
    var n = _.className,
      t = Modernizr._config.classPrefix || "";
    if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
      n = n.replace(r, "$1" + t + "js$2");
    }
    Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), w ? _.className.baseVal = n : _.className = n);
  }
  function s(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
      return n + t.toUpperCase();
    }).replace(/^-/, "");
  }
  function a(e, n) {
    return !!~("" + e).indexOf(n);
  }
  function f() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }
  function l(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }
  function u(e, n, t) {
    var o;
    for (var i in e) if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, "function") ? l(o, t || n) : o);
    return !1;
  }
  function p(e) {
    return e.replace(/([A-Z])/g, function (e, n) {
      return "-" + n.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }
  function d() {
    var e = n.body;
    return e || (e = f(w ? "svg" : "body"), e.fake = !0), e;
  }
  function c(e, t, r, o) {
    var i,
      s,
      a,
      l,
      u = "modernizr",
      p = f("div"),
      c = d();
    if (parseInt(r, 10)) for (; r--;) a = f("div"), a.id = o ? o[r] : u + (r + 1), p.appendChild(a);
    return i = f("style"), i.type = "text/css", i.id = "s" + u, (c.fake ? c : p).appendChild(i), c.appendChild(p), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), p.id = u, c.fake && (c.style.background = "", c.style.overflow = "hidden", l = _.style.overflow, _.style.overflow = "hidden", _.appendChild(c)), s = t(p, e), c.fake ? (c.parentNode.removeChild(c), _.style.overflow = l, _.offsetHeight) : p.parentNode.removeChild(p), !!s;
  }
  function m(n, r) {
    var o = n.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) if (e.CSS.supports(p(n[o]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) i.push("(" + p(n[o]) + ":" + r + ")");
      return i = i.join(" or "), c("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == getComputedStyle(e, null).position;
      });
    }
    return t;
  }
  function v(e, n, o, i) {
    function l() {
      p && (delete z.style, delete z.modElem);
    }
    if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var u = m(e, o);
      if (!r(u, "undefined")) return u;
    }
    for (var p, d, c, v, h, y = ["modernizr", "tspan", "samp"]; !z.style && y.length;) p = !0, z.modElem = f(y.shift()), z.style = z.modElem.style;
    for (c = e.length, d = 0; c > d; d++) if (v = e[d], h = z.style[v], a(v, "-") && (v = s(v)), z.style[v] !== t) {
      if (i || r(o, "undefined")) return l(), "pfx" == n ? v : !0;
      try {
        z.style[v] = o;
      } catch (g) {}
      if (z.style[v] != h) return l(), "pfx" == n ? v : !0;
    }
    return l(), !1;
  }
  function h(e, n, t, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
      a = (e + " " + S.join(s + " ") + s).split(" ");
    return r(n, "string") || r(n, "undefined") ? v(a, n, o, i) : (a = (e + " " + E.join(s + " ") + s).split(" "), u(a, n, t));
  }
  var y = [],
    g = [],
    C = {
      _version: "3.3.1",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0
      },
      _q: [],
      on: function on(e, n) {
        var t = this;
        setTimeout(function () {
          n(t[e]);
        }, 0);
      },
      addTest: function addTest(e, n, t) {
        g.push({
          name: e,
          fn: n,
          options: t
        });
      },
      addAsyncTest: function addAsyncTest(e) {
        g.push({
          name: null,
          fn: e
        });
      }
    },
    Modernizr = function Modernizr() {};
  Modernizr.prototype = C, Modernizr = new Modernizr();
  var _ = n.documentElement,
    w = "svg" === _.nodeName.toLowerCase(),
    x = "Moz O ms Webkit",
    S = C._config.usePrefixes ? x.split(" ") : [];
  C._cssomPrefixes = S;
  var b = function b(n) {
    var r,
      o = prefixes.length,
      i = e.CSSRule;
    if ("undefined" == typeof i) return t;
    if (!n) return !1;
    if (n = n.replace(/^@/, ""), r = n.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + n;
    for (var s = 0; o > s; s++) {
      var a = prefixes[s],
        f = a.toUpperCase() + "_" + r;
      if (f in i) return "@-" + a.toLowerCase() + "-" + n;
    }
    return !1;
  };
  C.atRule = b;
  var E = C._config.usePrefixes ? x.toLowerCase().split(" ") : [];
  C._domPrefixes = E;
  var j = {
    elem: f("modernizr")
  };
  Modernizr._q.push(function () {
    delete j.elem;
  });
  var z = {
    style: j.elem.style
  };
  Modernizr._q.unshift(function () {
    delete z.style;
  }), C.testAllProps = h;
  var N = C.prefixed = function (e, n, t) {
    return 0 === e.indexOf("@") ? b(e) : (-1 != e.indexOf("-") && (e = s(e)), n ? h(e, n, t) : h(e, "pfx"));
  };
  Modernizr.addTest("objectfit", !!N("objectFit"), {
    aliases: ["object-fit"]
  }), o(), i(y), delete C.addTest, delete C.addAsyncTest;
  for (var P = 0; P < Modernizr._q.length; P++) Modernizr._q[P]();
  e.Modernizr = Modernizr;
}(window, document);
// Rimosso 20190408 - Da' errore e interferisce con i click sulla form "Iscriviti a Guida Mandarda"
// Ref. https://github.com/ftlabs/fastclick/issues/510
// Ref. https://developers.google.com/web/updates/2013/12/300ms-tap-delay-gone-away
// Fastclick
//window.addEventListener('load', function() {
//    new FastClick(document.body);
//}, false);

$(document).ready(function () {
  //Smooth anchor scroll landing

  $('a.anchor:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate({
          scrollTop: target.offset().top - 175
        }, 1000);
        return false;
      }
    }
  });

  // Shrinking header
  var addBackground = 10;
  $(window).scroll(function () {
    var scroll = getCurrentScroll();
    if (scroll >= addBackground) {
      $(".header-wrap").addClass("whiteBg");
      //$('path').attr('fill', '#ccc');
    } else {
      $(".header-wrap").removeClass("whiteBg");
    }
  });
  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  $(".two-blocks.overlapped a.btn-secondary").on("mouseover", function (e) {
    $(".two-blocks__img").addClass("move");
  });
  $(".two-blocks.overlapped a.btn-secondary").on("mouseout", function (e) {
    $(".two-blocks__img").removeClass("move");
  });

  //Accordion

  /* var title = document.querySelectorAll(".accordion__header");
  for (var i = 0; i < title.length; i++) {
  	title[i].classList.add("js-header");
  	//console.log(title[i].classList);
  }
  	var copy = document.querySelectorAll(".accordion__content");
  for (var i = 0; i < copy.length; i++) {
  	copy[i].classList.add("js-content");
  	//console.log(copy[i].classList);
  }
  	$(".accordion .js-content").slideDown();
  var $title = $(".accordion .js-header");
  $title.click(function () {
  	$(this).next(copy).slideToggle();
  	//$(this).parent().siblings().children().next().slideUp();
  	$(this).toggleClass("active");
  	//$(this).parent().siblings().children().removeClass('active');
  	return false;
  }); */
  $(".js-header").on("click", function (e) {
    e.preventDefault();
    var $btn = $(this); // $(this) è il button.js-header
    var $content = $("#" + $btn.attr("aria-controls"));

    // Verifica se è attualmente espanso
    var isExpanded = $btn.attr("aria-expanded") === "true";

    // Toggle ARIA (cambia l'aspetto del CSS tramite :after)
    $btn.attr("aria-expanded", !isExpanded);

    // Animazione
    $content.stop(true, true).slideToggle(300);
  });
  // Modal

  //al caricamento pagina
  //$(".js .overlay").addClass('overlay-open');

  $('.js a[href="#modal"]').on("click", function (e) {
    $(".js .overlay").addClass("overlay-open");
  });
  $(".js .modal .btn-close").on("click", function (e) {
    e.preventDefault();
    $(".js .overlay").removeClass("overlay-open");
  });
  var modal = document.getElementById("modal");

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.classList.removeClass("overlay-open");
    }
  };

  // Scrolling overlay

  var lastScrollTop = 0;
  $(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st < lastScrollTop) {
      $(".overlay").addClass("scroll");
    } else {
      $(".overlay").removeClass("scroll");
    }
    lastScrollTop = st;
  });

  //Menu Hamburger

  $(".nav-expander").on("click", function (e) {
    e.preventDefault();

    // 1. Facciamo il toggle della classe sul body
    var body = $("body");
    body.toggleClass("nav-expanded");

    // 2. Verifichiamo se ora è aperto
    var isOpen = body.hasClass("nav-expanded");

    // 3. Prepariamo il testo corretto
    var labelText = isOpen ? "Chiudi il menu" : "Apri il menu";

    // 4. Aggiorniamo dinamicamente tutti gli attributi
    $(this).attr("aria-expanded", isOpen) // Comunica lo stato (true/false)
    .attr("aria-label", labelText) // Cambia l'etichetta tecnica
    .find(".sr-only").text(labelText); // Cambia il testo per screen reader
  });

  // Hero Carousel

  $(".hero-carousel").slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    //lazyLoad: 'ondemand',

    responsive: [{
      breakpoint: 768,
      //fino a
      settings: {
        arrows: false
      }
    }]
  });

  // Carousel pagina dettaglio

  $(".slider-detail").slick({
    //dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    centerPadding: "0",
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: false
      }
    }]
  });

  // Slick lightbox
  // se matcha da 768px in su, si attiva il lightbox
  var mq = window.matchMedia("(min-width: 768px)");
  if (mq.matches) {
    $(".slider-detail").slickLightbox({
      src: "src-full",
      itemSelector: "div img"
    });
  }

  /* $('.slider-for').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         fade: true,
         asNavFor: '.slider-nav',
         //centerMode: true
         //variableWidth: true
     });
      $('.slider-nav').slick({
         arrows:false,
         slidesToShow: 3,
         slidesToScroll: 1,
         asNavFor: '.slider-for',
         centerMode: true,
         focusOnSelect: true
         //variableWidth: true
     });*/

  //all'avvio del modal la prima slide non si vede
  // --> So manually refresh positioning of slick
  /*$('a#open').on("click", function() { 
         $('.overlay').addClass('overlay-open'); 
         $('.slider-for').slick('setPosition');  
         $('.slider-nav').slick('setPosition'); 
     });
      $('.btn-close').on('click',function(e){
         e.preventDefault();
         $('.overlay').removeClass('overlay-open'); 
         $('.slider-for').unslick;  
         $('.slider-nav').unslick; 
     });*/

  // gallery grande pagina foto mansarde
  $(".sfoglia").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: "ondemand"
    //lazyLoad: "progressive",
    //lazyLoad: "anticipated",
  });
  $(document).on("click", ".thumbnails a.thumb", function (e) {
    e.preventDefault();
    $(".sfoglia").slick("slickGoTo", $(".thumbnails a.thumb").index(this), true);
    $(".big")[0].showModal();
    $(".sfoglia").slick("setPosition");
    /* $(".big").addClass("openThumb");
          $(".thumbnails a.thumb").attr('aria-hidden', true); */
  });
  /*
     $('.thumbnails a.thumb').on('click',function(e){
         e.preventDefault();
         $('.sfoglia').slick('slickGoTo',$('.thumbnails a.thumb').index(this),true);
         $('.big').addClass('openThumb');
     })
     */

  $(document).on("click", ".big .close", function (e) {
    $(".big")[0].close();
    /* $(".big").removeClass("openThumb");
          $(".thumbnails a.thumb").removeAttr('aria-hidden'); */
  });
  /*
     $('.big .close').on('click',function(){
         $('.big').removeClass('openThumb');
     })
     */

  // Test slideshow infinito
  /*
     $(document).on('click', '.slick-prev, .slick-next', function(e) {
         var currSlide = $('.sfoglia .slick-current.slick-active').attr('data-slick-index');
         console.log('currSlide = '+currSlide);
     });
     */

  /*
     $(document).on('beforeChange', '.sfoglia', function(e, slick, currentSlide, nextSlide) {
         console.log('beforeChange - currentSlide = '+currentSlide);
         console.log('beforeChange - nextSlide = '+nextSlide);
     });
     */

  //slider categorie

  $(".slider-category").slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    //lazyLoad: 'ondemand',
    lazyLoad: "progressive",
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: false
      }
    }]
  });

  //slider contenuti articolo

  $(".slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 2561,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true
      }
    }, {
      breakpoint: 992,
      settings: {
        infinite: false,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 601,
      settings: {
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  // Slider correlati home
  $(".sliderCorrelati__slider").slick({
    infinite: false,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: "ondemand",
    responsive: [{
      breakpoint: 1200,
      settings: {
        infinite: false,
        slidesToShow: 3.5
      }
    }, {
      breakpoint: 768,
      settings: {
        infinite: false,
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        infinite: false,
        slidesToShow: 1
      }
    }]
  });

  // Slider Guide home
  $(".sliderGuide__slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    //prevArrow: null,
    lazyLoad: "ondemand",
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5
      }
    }, {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }]
  });

  // Slider Before After
  $('.beforeAfterSlider').on('init reInit afterChange', function (event, slick, currentSlide) {
    // Rimuove il focus da tutti gli switch nelle slide
    $('.slick-slide [role="switch"]').attr('tabindex', '-1');
    // Lo ripristina solo per la slide attiva (anche se sono più di una)
    $('.slick-active [role="switch"]').attr('tabindex', '0');
  });
  $(".beforeAfterSlider").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [{
      breakpoint: 2561,
      settings: {
        infinite: false,
        slidesToShow: 1.75,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 992,
      settings: {
        infinite: false,
        slidesToShow: 1.75,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 601,
      settings: {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  //Fade masthead home
  $('.fadeSlick').slick({
    dots: false,
    arrows: false,
    infinite: true,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 2500
  });

  // navigazione tastiera gallery
  var $carousel = $(".hero-carousel, .slider-detail, .sfoglia, .slider-category ");
  $(document).on("keydown", function (e) {
    if (e.keyCode == 37) {
      $carousel.slick("slickPrev");
    }
    if (e.keyCode == 39) {
      $carousel.slick("slickNext");
    }
  });

  /*$('.slider-category').slick({
         infinite: false,
         speed: 300,
         slidesToShow: 7,
         centerMode: false,
         variableWidth: false,
         lazyLoad: 'progressive',
          responsive: [
             {
                 breakpoint: 1500,
                 settings: {
                     slidesToShow: 6
                 }
             },
             {
                 breakpoint: 1200,
                 settings: {
                     slidesToShow: 5
                 }
             },
             {
                 breakpoint: 1024,
                 settings: {
                     slidesToShow: 4
                 }
             },
             {
                 breakpoint: 600,
                 settings: {
                     arrows: false
                 }
             },
  
             {
                 breakpoint: 600,
                 settings: {
                     slidesToShow: 2
                 }
             },
             {
                 breakpoint: 480,
                 settings: {
                     slidesToShow: 1
                 }
             }
             // You can unslick at a given breakpoint now by adding:
             // settings: "unslick"
             // instead of a settings object
         ]
      });
  */

  // apertura lightbox immagini articoli

  //$(".centrale-wrap").slickLightbox({
  $(".single-post .page-articolo").slickLightbox({
    src: "href",
    itemSelector: "a.zoomIcon",
    //       swipe:!1,
    //        touchMove: false

    slick: {
      swipe: false
    }
  }).on({
    "show.slickLightbox": function showSlickLightbox() {
      $("body").css("overflow", "hidden");
    },
    "hide.slickLightbox": function hideSlickLightbox() {
      $("body").css("overflow", "initial");
    }
  });

  // CTA sticky bottom
  $(".toggle-bottom-row").click(function () {
    $(".bottom-row").toggleClass("is-closed");
  });

  // Fascetta progettisti
  $(".fascetta .close").click(function () {
    $(".fascetta").slideUp("slow");
  });

  //Search
  $("#open-search, #open-search-mobile, #open-search-link").on("click", function (e) {
    e.preventDefault();
    $(".search-form-wrapper").addClass("search--open");
    $(".search__input").focus();
    $("main").addClass("main-wrap--move");
  });
  $(".search-form-wrapper button").on("click", function () {
    $(".search-form-wrapper").removeClass("search--open");
    $("main").removeClass("main-wrap--move");
  });

  /* $("a[href='#searching-search'], a[href='#searching-search-mobile']").on('click',function(e){
         $('.search-form-wrapper').addClass('open');
     });
     $('.search-form-wrapper .btn-close').on('click',function(e){
         e.preventDefault();
         $('.search-form-wrapper').removeClass('open');  
     });*/
  document.addEventListener("keyup", function (ev) {
    // escape key.
    if (ev.keyCode == 27) {
      $(".search-form-wrapper").removeClass("search--open");
      $("main").removeClass("main-wrap--move");
    }
  });

  // disable scroll wheel on iframe google map
  $(".map").click(function () {
    $(".map iframe").css("pointer-events", "auto");
  });
  $(".map").mouseleave(function () {
    $(".map iframe").css("pointer-events", "none");
  });

  // Icona immagini lightbox
  $(".single-post img").parent("a").not('[href*="video.velux"], .noZoom').addClass("zoomIcon");
  //$( ".single-post img").parent('a').addClass('zoomIcon');

  // Inibisco i link della gallery foto finche' non viene caricato il js del lightbox (deferred)
  $(".thumbnails a.thumb").on("click", function (e) {
    e.preventDefault();
  });
  if ($("body").hasClass("post-type-archive-faq")) {
    if (window.location.hash !== "") {
      var myFaqID = window.location.hash;
      $("html, body").animate({
        scrollTop: $(myFaqID).offset().top - 150
      }, 1);
      /*
               var myFaqID = window.location.hash;
               var lastScrollTop = 0;
               $(myFaqID).css("padding-top", "150px");
               setTimeout(
                   $(window).scroll(function(e) {
                       var st = $(this).scrollTop();
                       if (st > lastScrollTop){
                           <?php // downscroll code ?>
                       } else {
                           <?php // upscroll code ?>
                           $(myFaqID).css("padding-top", "0"); 
                           //$(myFaqID).animate({ "padding-top": 0, }, 200);
                       }
                       lastScrollTop = st; 
                   }), 
               1000);
               */
    }
  }
  if ($("body").hasClass("page-template-pagina-guide")) {
    if (window.location.hash !== "") {
      var myTarget = window.location.hash;
      //console.log(myTarget);
      $("html, body").animate({
        scrollTop: $(myTarget).offset().top - 130
      }, 1);
    }
  }
  var countIscrivitiClick = 0;
  $(document).on("click", ".primary-nav .btn-primary", function (e) {
    e.preventDefault();
    var offsetTop = 125;
    //var offsetTop = 175;
    if ($('body').hasClass('home')) offsetTop = 125;
    var isMobile = $(".nav-expander").is(":visible");

    /*
          countIscrivitiClick++;
          if (! isMobile && countIscrivitiClick == 1) {
              offsetTop = -175;
          }
          */

    $("html, body").animate({
      scrollTop: $("#guida-mansarda").offset().top - offsetTop
      //scrollTop: $("#newsletter_form").offset().top - offsetTop,
    }, 1000);
    if (isMobile) {
      $(".nav-expander").click();
    }
  });

  // Copy link
  /* $('.buttonCopyText').on("click", function (event) {
  	event.preventDefault();
  		var copyText = $(this).prev('.inputCopyText');
  	copyText[0].select();
  	copyText[0].setSelectionRange(0, 99999); // For mobile devices
  	document.execCommand("copy");
  		$(this).find('.copyTextTooltip').css('display', 'block');
  	//document.execCommand("copy");
  	setTimeout(function () {
  		$(this).find('.copyTextTooltip').css('display', 'none');
  	}, 1000);
  }); */

  $('.buttonCopyText').on("click", function (event) {
    event.preventDefault();
    var $btn = $(this);
    var textToCopy = $btn.prev().val();
    //var textToCopy = $('#textToCopy').val();

    var $status = $btn.next();
    //var $status = $('#copyStatus');

    var $tooltip = $btn.find('.copyTextTooltip');

    // Funzione per gestire il feedback visivo e vocale
    function showSuccess() {
      $tooltip.show();
      $status.text("Link copiato negli appunti");
      setTimeout(function () {
        $tooltip.hide();
        $status.text("");
      }, 2000);
    }

    // Prova prima con la moderna Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy).then(showSuccess);
    } else {
      // FALLBACK: Metodo classico per contesti HTTP o browser datati
      var $tempInput = $("<input>");
      $("body").append($tempInput);
      $tempInput.val(textToCopy).select();
      try {
        document.execCommand("copy");
        showSuccess();
      } catch (err) {
        $status.text("Errore durante la copia");
      }
      $tempInput.remove();
      // Riporta il focus sul bottone per non perdere l'orientamento (A11y)
      $btn.focus();
    }
  });

  // Slider Before After
  /* $('.beforeAfterSlider div[role="switch"]').click(function(){
  	if(($(this).siblings('.beforeAfterSliderImg').find('img.light')).hasClass("fadeOut"))
  		{
  			$(this).siblings('.beforeAfterSliderImg').find('img.light').toggleClass('fadeOut fadeIn').siblings('img').toggleClass('fadeOut fadeIn');
  		}
  	else {
  			$(this).siblings('.beforeAfterSliderImg').find('img.light').toggleClass('fadeIn fadeOut').siblings('img').toggleClass('fadeOut fadeIn');
  		}
  }); */

  // Funzione unica per cambiare lo stato
  function toggleSwitch(element) {
    var $this = $(element);
    var isChecked = $this.attr('aria-checked') === 'true';
    var newState = !isChecked;
    $this.attr('aria-checked', newState.toString());
    var $slide = $this.closest('.slick-slide');
    var $imgAfter = $slide.find('img.light');
    var $imgBefore = $slide.find('img').not('.light');
    if (newState) {
      $imgAfter.addClass('fadeIn').removeClass('fadeOut');
      $imgBefore.addClass('fadeOut').removeClass('fadeIn');
    } else {
      $imgAfter.addClass('fadeOut').removeClass('fadeIn');
      $imgBefore.addClass('fadeIn').removeClass('fadeOut');
    }
  }

  // 1. GESTIONE CLICK (Fase di cattura per superare Slick)
  document.addEventListener('click', function (e) {
    var switchEl = e.target.closest('[role="switch"]');
    if (switchEl) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleSwitch(switchEl);
    }
  }, true);

  // 2. GESTIONE TASTIERA
  document.addEventListener('keydown', function (e) {
    var switchEl = e.target.closest('[role="switch"]');
    if (switchEl) {
      // Intercettiamo solo Invio (Enter) o Spazio ( )
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Impedisce lo scroll della pagina con lo Spazio
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleSwitch(switchEl);
      }
    }
  }, true);
});

// DEFERRED IMAGES
/*
function init() {
    var imgDefer = document.getElementsByTagName('img');
    for (var i=0; i<imgDefer.length; i++) {
        if(imgDefer[i].getAttribute('data-src')) {
            imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
            imgDefer[i].classList.add("app")
        } } }
window.onload = init;
*/

// FALLBACK OBJECT-FIT IE
if (!Modernizr.objectfit) {
  $(".correlato__img, .slider-category, .archivio__img, .two-blocks__img, .categoria__selected__list, .masthead:not(.home)").each(function () {
    //console.log("Sono in FALLBACK OBJECT-FIT IE");

    var childImg = $(this).find("img");
    var imgSrc = childImg.attr("src");
    if (!imgSrc) imgSrc = childImg.attr("data-src");
    if (!imgSrc) imgSrc = childImg.attr("data-src-objectfit");
    //console.log(imgSrc);

    if (!imgSrc) return;
    var fitType = "cover";
    /*
          if($(this).data('fit-type')) {
              fitType = $(this).data('fit-type');
          }
          */

    $(this).css({
      background: 'transparent url("' + imgSrc + '") no-repeat center center/' + fitType
    });
    childImg.remove();
  });
}
function isValInDataLayer(myVal) {
  if ((typeof dataLayer === "undefined" ? "undefined" : _typeof(dataLayer)) === "object") for (i in dataLayer) if (typeof dataLayer[i].event !== "undefined" && dataLayer[i].event == myVal) return true;
  return false;
}

/* mgigli 20221104 - Spostato in file a parte (hubspot-forms.js) caricato in head dopo le librerie Hubspot
// Form Hubspot (Guida Mansarda)
// NB per istanziare la stessa form piu' volte devo ripetere i blocchi, perche' il target puo' essere solo un elemento singolo
if (typeof hbspt !== "undefined") {
	hbspt.forms.create({
		target: "#newsletter_form",
		css: "",
		portalId: "427615",
		formId: "2334882c-074b-4a54-a762-3dc5f3510721",
		onFormSubmit: function ($form) {
			// Tracking con Google Tag Manager
			if (typeof dataLayer === "object") {
				dataLayer.push({ event: "iscrizione-guida-mansarda" });
			} else {
				console.log("dataLayer.push({'event': 'iscrizione-guida-mansarda'});");
			}
		},
	});
	hbspt.forms.create({
		target: "#newsletter_form_footer",
		css: "",
		portalId: "427615",
		formId: "2334882c-074b-4a54-a762-3dc5f3510721",
		onFormSubmit: function ($form) {
			// Tracking con Google Tag Manager
			if (typeof dataLayer === "object") {
				dataLayer.push({ event: "iscrizione-guida-mansarda" });
			} else {
				console.log("dataLayer.push({'event': 'iscrizione-guida-mansarda'});");
			}
		},
	});
}
*/

// Elementi con animazione in entrata
//const animated_elements = [].slice.call(document.querySelectorAll('.benefit'));
//animated_elements.forEach(animated_element => observer.observe(animated_element)); // add an element to the set of target elements being watched

// IntersectionObserver Supported
var config = {
  root: null,
  // relative to document viewport
  rootMargin: "50px 0px",
  // margin around root. Values are similar to css property. Unitless values not allowed
  threshold: 0 // visible amount of item shown in relation to root
};
var observer = new IntersectionObserver(onChange, config);
function onChange(changes, observer) {
  changes.forEach(function (change) {
    if (change.intersectionRatio > 0) {
      // check if the target is visible (greater than 0)
      // Stop watching and load the image

      if (change.target.tagName.toLowerCase() == "img" || change.target.tagName.toLowerCase() == "source") {
        loadImage(change.target);
      } else {
        enterClass(change.target);
      }
      observer.unobserve(change.target);
    }
  });
}
function loadImage(image) {
  //image.classList.add('fade-in');
  if (image.dataset && image.dataset.src) {
    image.src = image.dataset.src;
  }
  if (image.dataset && image.dataset.srcset) {
    image.srcset = image.dataset.srcset;
  }
}
function enterClass(el) {
  if (!el.classList.contains("entering")) {
    el.classList.add("entering");
  }
}

// Immagini da caricare in LazyLoad
var images = [].slice.call(document.querySelectorAll("[data-src], [data-srcset]"));
//const images = [].slice.call(document.querySelectorAll('[data-src]'));
images.forEach(function (img) {
  return observer.observe(img);
}); // add an element to the set of target elements being watched

//Reload on resize
/*
var windowWidth = $(window).width();
$(window).resize(function () {
	if ($(window).width() != windowWidth) {
		windowWidth = $(window).width();
		setTimeout(function () {
			window.location.reload();
		});
	}
});
*/

// Intersection observer per attivare voci menu contestuale 
if (window.matchMedia("(min-width: 768px)").matches) {
  var observerHeadingOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.75
    //threshold: [0, 0.25, 0.5, 0.75, 1] // trigger a diversi livelli di visibilità
  };
  var observerHeading = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var id = entry.target.getAttribute('id');
      if (entry.intersectionRatio > 0) {
        document.querySelectorAll('.article__menu li').forEach(function (item) {
          item.classList.remove('active');
        });
        document.querySelector(".article__menu li a[href=\"#".concat(id, "\"]")).parentElement.classList.add('active');
      }
      /* else {
                document.querySelector(`.article__menu li a[href="#${id}"]`).parentElement.classList.remove('active');
            } */
    });
  }, observerHeadingOptions);
  document.querySelectorAll('h2 span[id]').forEach(function (h2) {
    observerHeading.observe(h2);
  });
}
'use strict';
var Switch = /*#__PURE__*/function () {
  function Switch(domNode) {
    var _this = this;
    _classCallCheck(this, Switch);
    this.switchNode = domNode;
    this.switchNode.addEventListener('click', function () {
      return _this.toggleStatus();
    });
    this.switchNode.addEventListener('keydown', function (event) {
      return _this.handleKeydown(event);
    });
  }
  return _createClass(Switch, [{
    key: "handleKeydown",
    value: function handleKeydown(event) {
      // Only do something when space or return is pressed
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleStatus();
      }
    }

    // Switch state of a switch
  }, {
    key: "toggleStatus",
    value: function toggleStatus() {
      var currentState = this.switchNode.getAttribute('aria-checked') === 'true';
      var newState = String(!currentState);
      this.switchNode.setAttribute('aria-checked', newState);
    }
  }]);
}(); // Initialize switches
window.addEventListener('load', function () {
  // Initialize the Switch component on all matching DOM nodes
  Array.from(document.querySelectorAll('[role^=switch]')).forEach(function (element) {
    return new Switch(element);
  });
});